<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>Online Expo Settings
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>

    <!-- track end -->
    <!-- article -->

    <article>
      <div class="MbDevice">
        <div class="homeLeft">
          <div class="UserAccount ml-1">
            <span class="bold">Account :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
          <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
          <div class="expoInfo">
            <p class="bold" name="Exhibition"></p>
            <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
            <p>{{ eExhVenue }}</p>
          </div>
          <p class="clear"></p>
        </div>
      </div>

      <div class="MbDevice container" style="background-color: white">
        <div class="contentBoxStatus">
          <p class="mb-3 text-center" style="font-size: 12px">
            Please upload the complete information for the following items to
            ensure the visitors understand your company, products, and services
            clearly
          </p>

          <div
            class="mb-4 border text-center py-2"
            style="font-size: 12px; border-radius: 10px"
          >
            <div class="d-flex justify-content-around">
              <div>
                <a :href="`profile?no=${RegNo}`">
                  <div class="row justify-content-center align-items-center">
                    <div class="col-md-6">
                      <span
                        v-if="BasicinformationStatus == 1"
                        class="complete"
                      ></span>
                      <span v-else class="uncomplete"></span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <span style="color: black">Information </span>
                  </div>
                </a>
              </div>
              <div>
                <a :href="`product?no=${RegNo}`">
                  <div class="row justify-content-center align-items-center">
                    <div class="col-md-6">
                      <span v-if="ProductStatus !== 0" class="complete"></span>
                      <span v-else class="uncomplete"></span>
                    </div>
                    <div class="col-md-6">
                      <span class="border-dark text-dark">Products </span>
                    </div>
                  </div>
                </a>
              </div>

              <div>
                <a :href="`news?no=${RegNo}`">
                  <div class="row justify-content-center align-items-center">
                    <div class="col-md-6">
                      <span
                        v-if="PressReleaseStatus !== 0"
                        class="complete"
                      ></span>
                      <span v-else class="uncomplete"></span>
                    </div>
                    <div class="col-md-6">
                      <span style="color: black">Press Release </span>
                    </div>
                  </div>
                </a>
              </div>

              <div>
                <a :href="`video?no=${RegNo}`">
                  <div class="row justify-content-center align-items-center">
                    <div class="col-md-6">
                      <span v-if="VideoStatus !== 0" class="complete"></span>
                      <span v-else class="uncomplete"></span>
                    </div>
                    <div class="col-md-6">
                      <span style="color: black">Video </span>
                    </div>
                  </div>
                </a>
              </div>

              <div v-if="showOnlineStatus">
                <a :href="`onlineExpo?no=${RegNo}`">
                  <div class="row justify-content-center align-items-center">
                    <div class="col-md-6">
                      <span
                        v-if="OnlineExpolayoutStatus == 1"
                        class="complete"
                      ></span>
                      <span v-else class="uncomplete"></span>
                    </div>
                    <div class="col-md-6">
                      <span style="color: black">
                        <p>Online Expo</p>
                        <p>Settings</p>
                      </span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="container">
          <h1>Online Expo Settings</h1>
          <p class="my-3">&nbsp;</p>

          <div class="d-flex justify-content-center">
            <div class="row" v-show="Booth_Design == 'A1'">
              <div class="A1">
                <div class="text-center mb-2 mt-4" style="font-size: 18px">
                  Preview of booth display
                </div>
                <div class="MbExhType homesection">
                  <div class="Booth_MbTop">
                    <div class="MbLogobanner row align-items-center">
                      <div class="col-3">
                        <div class="MblogImgFrame">
                          <img
                            :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                            alt=""
                            width="60%"
                          />
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="LogoText">
                          {{ OnlineExpoProfile.MemberComName }}
                        </div>
                      </div>
                    </div>

                    <div v-show="hasCard">
                      <span
                        class="TopicMbA1_dotCard pointer"
                        @click="openInquiryModal"
                        ><i class="far fa-dot-circle"></i>
                        <div class="TopicMbA1_staffArea MbIconSize"></div>
                      </span>
                    </div>

                    <div v-show="!hasCard">
                      <a
                        :href="`onlineExpoCardInfo?no=${RegNo}`"
                        data-fancybox
                        data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                        data-type="iframe"
                        class="iframeFormCard AddRegLink"
                      >
                        <span class="TopicMbA1_dotCard pointer"
                          ><i class="far fa-dot-circle MbIconSize"></i>
                          <div class="TopicMbA1_staffArea"></div>
                        </span>
                      </a>
                    </div>

                    <img src="@/assets/images/Expo_Topic1.png" width="320px" />

                    <a :href="ExpoL_Banner1" data-fancybox>
                      <img
                        :src="ExpoM_Banner1"
                        class="mTopicA1_Banner01 BannerHover img-thumbnailA1M"
                      />
                      <span class="TopicMbA1_dot1"
                        ><i class="far fa-dot-circle MbIconSize"></i
                      ></span>
                    </a>

                    <a :href="ExpoL_Banner2" data-fancybox>
                      <img
                        :src="ExpoM_Banner2"
                        class="mTopicA1_Banner02 BannerHover img-thumbnailA1M"
                      />
                      <span class="TopicMbA1_dot2"
                        ><i class="far fa-dot-circle MbIconSize"></i
                      ></span>
                    </a>

                    <span v-if="ExpovideoLink">
                      <a
                        :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                        frameborder="0"
                        allow="autoplay; encrypted-media"
                        data-fancybox
                        data-width="640"
                        data-height="360"
                      >
                        <img
                          :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                          class="mTopicA1_Video BannerHover"
                        />
                        <span class="TopicMbA1_Video"
                          ><i class="far fa-dot-circle MbIconSize"></i
                        ></span>
                      </a>
                    </span>

                    <span
                      v-else-if="videoLink_Youku"
                      class="mTopicA1_Video"
                      style="background-color: #dfdfdfd9"
                    >
                      <a
                        :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                        data-fancybox
                        data-type="iframe"
                        data-width="640"
                        data-height="360"
                      >
                        <div
                          class="insideUK"
                          style="color: #5e5e5ecc; margin-top: 1px"
                        >
                          <i class="fas fa-play-circle"></i>
                        </div>
                      </a>
                    </span>
                    <span v-else>
                      <img
                        src="@/assets/images/default_video.jpg"
                        class="mTopicA1_Video BannerHover"
                      />
                    </span>
                  </div>

                  <div class="Mbfooter">
                    <div class="d-flex justify-content-around mt-3">
                      <div>
                        <div
                          class="text-center pointer iconOpenHover"
                          @click="openUserModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_profile.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Profile</div>
                        </div>
                        <div
                          class="text-center pointer iconOpenHover mt-3"
                          @click="openProductModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_products.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Products</div>
                        </div>
                      </div>
                      <div>
                        <div
                          class="text-center pointer iconOpenHover"
                          @click="openVideoModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_video.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Videos</div>
                        </div>

                        <div
                          class="text-center pointer iconOpenHover mt-3"
                          @click="openNewsModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_news.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Press Release</div>
                        </div>
                      </div>

                      <div>
                        <div
                          class="text-center pointer iconOpenHover"
                          @click="openInquiryModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_chat.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Inquiry</div>
                        </div>

                        <div class="pointer iconOpenHover mt-3">
                          <span>
                            <div class="text-center pointer iconOpenHover">
                              <img
                                src="@/assets/images/onlineExpo_favorite.png"
                                width="20px"
                                alt=""
                              />

                              <div style="font-size: 12px">Favorite</div>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center">
            <div
              class="row justify-content-center"
              v-show="Booth_Design == 'A2'"
            >
              <div class="A2">
                <div class="text-center mb-2 mt-4" style="font-size: 18px">
                  Preview of booth display
                </div>
                <div class="MbExhType homesection">
                  <div class="Booth_MbTop">
                    <div class="MbLogobanner row align-items-center">
                      <div class="col-3">
                        <div class="MblogImgFrame">
                          <img
                            :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                            alt=""
                            width="60%"
                          />
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="LogoText">
                          {{ OnlineExpoProfile.MemberComName }}
                        </div>
                      </div>
                    </div>

                    <div v-show="hasCard">
                      <span
                        class="TopicMbA2_dotCard pointer"
                        @click="openInquiryModal"
                        ><i class="far fa-dot-circle MbIconSize"></i>
                        <div class="TopicMbA2_staffArea"></div>
                      </span>
                    </div>

                    <div v-show="!hasCard">
                      <a
                        :href="`onlineExpoCardInfo?no=${RegNo}`"
                        data-fancybox
                        data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                        data-type="iframe"
                        class="iframeFormCard AddRegLink"
                      >
                        <span class="TopicMbA2_dotCard pointer"
                          ><i class="far fa-dot-circle MbIconSize"></i>
                          <div class="TopicMbA2_staffArea"></div>
                        </span>
                      </a>
                    </div>
                    <img src="@/assets/images/Expo_Topic2.png" width="320px" />
                    <a :href="ExpoL_Banner1" data-fancybox>
                      <img
                        :src="ExpoM_Banner1"
                        class="mTopicA2_Banner01 BannerHover"
                      />
                      <span class="TopicMbA2_dot1"
                        ><i class="far fa-dot-circle MbIconSize"></i
                      ></span>
                    </a>

                    <a :href="ExpoL_Banner2" data-fancybox>
                      <img
                        :src="ExpoM_Banner2"
                        class="mTopicA2_Banner02 BannerHover"
                      />
                      <span class="TopicMbA2_dot2"
                        ><i class="far fa-dot-circle MbIconSize"></i
                      ></span>
                    </a>

                    <span v-if="ExpovideoLink">
                      <a
                        :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                        frameborder="0"
                        allow="autoplay; encrypted-media"
                        data-fancybox
                        data-width="640"
                        data-height="360"
                      >
                        <img
                          :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                          class="mTopicA2_Video BannerHover"
                        />
                        <span class="TopicMbA2_Video"
                          ><i class="far fa-dot-circle MbIconSize"></i
                        ></span>
                      </a>
                    </span>

                    <span
                      v-else-if="videoLink_Youku"
                      class="mTopicA2_Video"
                      style="background-color: #dfdfdfd9"
                    >
                      <a
                        :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                        data-fancybox
                        data-type="iframe"
                        data-width="640"
                        data-height="360"
                      >
                        <div
                          class="insideUK"
                          style="color: #5e5e5ecc; margin-top: 1px"
                        >
                          <i class="fas fa-play-circle"></i>
                        </div>
                      </a>
                    </span>

                    <span v-else>
                      <img
                        src="@/assets/images/default_video.jpg"
                        class="mTopicA2_Video BannerHover"
                      />
                    </span>
                  </div>

                  <div class="Mbfooter">
                    <div class="d-flex justify-content-around mt-3">
                      <div>
                        <div
                          class="text-center pointer iconOpenHover"
                          @click="openUserModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_profile.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Profile</div>
                        </div>
                        <div
                          class="text-center pointer iconOpenHover mt-3"
                          @click="openProductModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_products.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Products</div>
                        </div>
                      </div>
                      <div>
                        <div
                          class="text-center pointer iconOpenHover"
                          @click="openVideoModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_video.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Videos</div>
                        </div>

                        <div
                          class="text-center pointer iconOpenHover mt-3"
                          @click="openNewsModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_news.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Press Release</div>
                        </div>
                      </div>

                      <div>
                        <div
                          class="text-center pointer iconOpenHover"
                          @click="openInquiryModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_chat.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Inquiry</div>
                        </div>

                        <div class="pointer iconOpenHover mt-3">
                          <span>
                            <div class="text-center pointer iconOpenHover">
                              <img
                                src="@/assets/images/onlineExpo_favorite.png"
                                width="20px"
                                alt=""
                              />

                              <div style="font-size: 12px">Favorite</div>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center">
            <div
              class="row justify-content-center"
              v-show="Booth_Design == 'A3'"
            >
              <div class="A3">
                <div class="text-center mb-2 mt-4" style="font-size: 18px">
                  Preview of booth display
                </div>

                <div class="MbExhType homesection">
                  <div class="Booth_MbTop">
                    <div class="MbLogobanner row align-items-center">
                      <div class="col-3">
                        <div class="MblogImgFrame">
                          <img
                            :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                            alt=""
                            width="60%"
                          />
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="LogoText">
                          {{ OnlineExpoProfile.MemberComName }}
                        </div>
                      </div>
                    </div>

                    <div v-show="hasCard">
                      <span
                        class="TopicMbA3_dotCard pointer"
                        @click="openInquiryModal"
                        ><i class="far fa-dot-circle MbIconSize"></i>
                        <div class="TopicMbA3_staffArea"></div>
                      </span>
                    </div>

                    <div v-show="!hasCard">
                      <a
                        :href="`onlineExpoCardInfo?no=${RegNo}`"
                        data-fancybox
                        data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                        data-type="iframe"
                        class="iframeFormCard AddRegLink"
                      >
                        <span class="TopicMbA3_dotCard pointer"
                          ><i class="far fa-dot-circle MbIconSize"></i>
                          <div class="TopicMbA3_staffArea"></div>
                        </span>
                      </a>
                    </div>
                    <img src="@/assets/images/Expo_TopicA3.png" width="320px" />
                    <a :href="ExpoL_Banner1" data-fancybox>
                      <img
                        :src="ExpoM_Banner1"
                        class="mTopicA3_Banner01 BannerHover img-thumbnailA3M"
                      />
                      <span class="TopicMbA3_dot1"
                        ><i class="far fa-dot-circle MbIconSize"></i
                      ></span>
                    </a>

                    <a :href="ExpoL_Banner2" data-fancybox>
                      <img
                        :src="ExpoM_Banner2"
                        class="mTopicA3_Banner02 BannerHover img-thumbnailA3M"
                      />
                      <span class="TopicMbA3_dot2"
                        ><i class="far fa-dot-circle MbIconSize"></i
                      ></span>
                    </a>

                    <span v-if="ExpovideoLink">
                      <a
                        :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                        frameborder="0"
                        allow="autoplay; encrypted-media"
                        data-fancybox
                        data-width="640"
                        data-height="360"
                      >
                        <img
                          :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                          class="mTopicA3_Video BannerHover"
                        />
                        <span class="TopicMbA3_Video"
                          ><i class="far fa-dot-circle MbIconSize"></i
                        ></span>
                      </a>
                    </span>

                    <span
                      v-else-if="videoLink_Youku"
                      class="mTopicA3_Video"
                      style="background-color: #dfdfdfd9"
                    >
                      <a
                        :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                        data-fancybox
                        data-type="iframe"
                        data-width="640"
                        data-height="360"
                      >
                        <div
                          class="insideUK"
                          style="color: #5e5e5ecc; margin-top: 1px"
                        >
                          <i class="fas fa-play-circle"></i>
                        </div>
                      </a>
                    </span>

                    <span v-else>
                      <img
                        src="@/assets/images/default_video.jpg"
                        class="mTopicA3_Video BannerHover"
                      />
                    </span>
                  </div>

                  <div class="Mbfooter">
                    <div class="d-flex justify-content-around mt-3">
                      <div>
                        <div
                          class="text-center pointer iconOpenHover"
                          @click="openUserModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_profile.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Profile</div>
                        </div>
                        <div
                          class="text-center pointer iconOpenHover mt-3"
                          @click="openProductModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_products.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Products</div>
                        </div>
                      </div>
                      <div>
                        <div
                          class="text-center pointer iconOpenHover"
                          @click="openVideoModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_video.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Videos</div>
                        </div>

                        <div
                          class="text-center pointer iconOpenHover mt-3"
                          @click="openNewsModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_news.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Press Release</div>
                        </div>
                      </div>

                      <div>
                        <div
                          class="text-center pointer iconOpenHover"
                          @click="openInquiryModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_chat.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Inquiry</div>
                        </div>

                        <div class="pointer iconOpenHover mt-3">
                          <span>
                            <div class="text-center pointer iconOpenHover">
                              <img
                                src="@/assets/images/onlineExpo_favorite.png"
                                width="20px"
                                alt=""
                              />

                              <div style="font-size: 12px">Favorite</div>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center">
            <div
              class="row justify-content-center"
              v-show="Booth_Design == 'A4'"
            >
              <div class="A4">
                <div class="text-center mb-2 mt-4" style="font-size: 18px">
                  Preview of booth display
                </div>
                <div class="MbExhType homesection">
                  <div class="Booth_MbTop">
                    <div class="MbLogobanner row align-items-center">
                      <div class="col-3">
                        <div class="MblogImgFrame">
                          <img
                            :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                            alt=""
                            width="60%"
                          />
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="LogoText">
                          {{ OnlineExpoProfile.MemberComName }}
                        </div>
                      </div>
                    </div>

                    <div v-show="hasCard">
                      <span
                        class="TopicMbA4_dotCard pointer"
                        @click="openInquiryModal"
                        ><i class="far fa-dot-circle MbIconSize"></i>
                        <div class="TopicMbA4_staffArea"></div>
                      </span>
                    </div>

                    <div v-show="!hasCard">
                      <a
                        :href="`onlineExpoCardInfo?no=${RegNo}`"
                        data-fancybox
                        data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                        data-type="iframe"
                        class="iframeFormCard AddRegLink"
                      >
                        <span class="TopicMbA4_dotCard pointer"
                          ><i class="far fa-dot-circle MbIconSize"></i>
                          <div class="TopicMbA4_staffArea"></div>
                        </span>
                      </a>
                    </div>
                    <img src="@/assets/images/Expo_TopicA4.png" width="320px" />
                    <a :href="ExpoL_Banner1" data-fancybox>
                      <img
                        :src="ExpoM_Banner1"
                        class="mTopicA4_Banner01 BannerHover"
                      />
                      <span class="TopicMbA4_dot1"
                        ><i
                          class="far fa-dot-circle MbIconSize img-thumbnailA4M"
                        ></i
                      ></span>
                    </a>

                    <a :href="ExpoL_Banner2" data-fancybox>
                      <img
                        :src="ExpoM_Banner2"
                        class="mTopicA4_Banner02 BannerHover"
                      />
                      <span class="TopicMbA4_dot2"
                        ><i
                          class="far fa-dot-circle MbIconSize img-thumbnailA4M"
                        ></i
                      ></span>
                    </a>

                    <span v-if="ExpovideoLink">
                      <a
                        :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                        frameborder="0"
                        allow="autoplay; encrypted-media"
                        data-fancybox
                        data-width="640"
                        data-height="360"
                      >
                        <img
                          :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                          class="mTopicA4_Video BannerHover"
                        />
                        <span class="TopicMbA4_Video"
                          ><i class="far fa-dot-circle MbIconSize"></i
                        ></span>
                      </a>
                    </span>

                    <span
                      v-else-if="videoLink_Youku"
                      class="mTopicA4_Video"
                      style="background-color: #dfdfdfd9"
                    >
                      <a
                        :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                        data-fancybox
                        data-type="iframe"
                        data-width="640"
                        data-height="360"
                      >
                        <div
                          class="insideUK"
                          style="color: #5e5e5ecc; margin-top: 1px"
                        >
                          <i class="fas fa-play-circle"></i>
                        </div>
                      </a>
                    </span>

                    <span v-else>
                      <img
                        src="@/assets/images/default_video.jpg"
                        class="mTopicA4_Video BannerHover"
                      />
                    </span>
                  </div>

                  <div class="Mbfooter">
                    <div class="d-flex justify-content-around mt-3">
                      <div>
                        <div
                          class="text-center pointer iconOpenHover"
                          @click="openUserModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_profile.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Profile</div>
                        </div>
                        <div
                          class="text-center pointer iconOpenHover mt-3"
                          @click="openProductModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_products.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Products</div>
                        </div>
                      </div>
                      <div>
                        <div
                          class="text-center pointer iconOpenHover"
                          @click="openVideoModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_video.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Videos</div>
                        </div>

                        <div
                          class="text-center pointer iconOpenHover mt-3"
                          @click="openNewsModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_news.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Press Release</div>
                        </div>
                      </div>

                      <div>
                        <div
                          class="text-center pointer iconOpenHover"
                          @click="openInquiryModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_chat.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Inquiry</div>
                        </div>

                        <div class="pointer iconOpenHover mt-3">
                          <span>
                            <div class="text-center pointer iconOpenHover">
                              <img
                                src="@/assets/images/onlineExpo_favorite.png"
                                width="20px"
                                alt=""
                              />

                              <div style="font-size: 12px">Favorite</div>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center">
            <div
              class="row justify-content-center"
              v-show="Booth_Design == 'A5'"
            >
              <div class="A5">
                <div class="text-center mb-2 mt-4" style="font-size: 18px">
                  Preview of booth display
                </div>
                <div class="MbExhType homesection">
                  <div class="Booth_MbTop">
                    <div class="MbLogobanner row align-items-center">
                      <div class="col-3">
                        <div class="MblogImgFrame">
                          <img
                            :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                            alt=""
                            width="60%"
                          />
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="LogoText">
                          {{ OnlineExpoProfile.MemberComName }}
                        </div>
                      </div>
                    </div>

                    <div v-show="hasCard">
                      <span
                        class="TopicMbA5_dotCard pointer"
                        @click="openInquiryModal"
                        ><i class="far fa-dot-circle MbIconSize"></i>
                        <div class="TopicMbA5_staffArea"></div>
                      </span>
                    </div>

                    <div v-show="!hasCard">
                      <a
                        :href="`onlineExpoCardInfo?no=${RegNo}`"
                        data-fancybox
                        data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                        data-type="iframe"
                        class="iframeFormCard AddRegLink"
                      >
                        <span class="TopicMbA5_dotCard pointer"
                          ><i class="far fa-dot-circle MbIconSize"></i>
                          <div class="TopicMbA5_staffArea"></div>
                        </span>
                      </a>
                    </div>
                    <img src="@/assets/images/Expo_TopicA5.png" width="320px" />
                    <a :href="ExpoL_Banner1" data-fancybox>
                      <img
                        :src="ExpoM_Banner1"
                        class="mTopicA5_Banner01 BannerHover img-thumbnailA5M"
                      />
                      <span class="TopicMbA5_dot1"
                        ><i class="far fa-dot-circle MbIconSize"></i
                      ></span>
                    </a>

                    <a :href="ExpoL_Banner2" data-fancybox>
                      <img
                        :src="ExpoM_Banner2"
                        class="mTopicA5_Banner02 BannerHover img-thumbnailA5M"
                      />
                      <span class="TopicMbA5_dot2"
                        ><i class="far fa-dot-circle MbIconSize"></i
                      ></span>
                    </a>

                    <span v-if="ExpovideoLink">
                      <a
                        :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                        frameborder="0"
                        allow="autoplay; encrypted-media"
                        data-fancybox
                        data-width="640"
                        data-height="360"
                      >
                        <img
                          :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                          class="mTopicA5_Video BannerHover"
                        />
                        <span class="TopicMbA5_Video"
                          ><i class="far fa-dot-circle MbIconSize"></i
                        ></span>
                      </a>
                    </span>

                    <span
                      v-else-if="videoLink_Youku"
                      class="mTopicA5_Video"
                      style="background-color: #dfdfdfd9"
                    >
                      <a
                        :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                        data-fancybox
                        data-type="iframe"
                        data-width="640"
                        data-height="360"
                      >
                        <div
                          class="insideUK"
                          style="color: #5e5e5ecc; margin-top: 1px"
                        >
                          <i class="fas fa-play-circle"></i>
                        </div>
                      </a>
                    </span>

                    <span v-else>
                      <img
                        src="@/assets/images/default_video.jpg"
                        class="mTopicA5_Video BannerHover"
                      />
                    </span>
                  </div>

                  <div class="Mbfooter">
                    <div class="d-flex justify-content-around mt-3">
                      <div>
                        <div
                          class="text-center pointer iconOpenHover"
                          @click="openUserModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_profile.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Profile</div>
                        </div>
                        <div
                          class="text-center pointer iconOpenHover mt-3"
                          @click="openProductModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_products.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Products</div>
                        </div>
                      </div>
                      <div>
                        <div
                          class="text-center pointer iconOpenHover"
                          @click="openVideoModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_video.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Videos</div>
                        </div>

                        <div
                          class="text-center pointer iconOpenHover mt-3"
                          @click="openNewsModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_news.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Press Release</div>
                        </div>
                      </div>

                      <div>
                        <div
                          class="text-center pointer iconOpenHover"
                          @click="openInquiryModal"
                        >
                          <img
                            src="@/assets/images/onlineExpo_chat.png"
                            width="20px"
                            alt=""
                          />
                          <div style="font-size: 12px">Inquiry</div>
                        </div>

                        <div class="pointer iconOpenHover mt-3">
                          <span>
                            <div class="text-center pointer iconOpenHover">
                              <img
                                src="@/assets/images/onlineExpo_favorite.png"
                                width="20px"
                                alt=""
                              />

                              <div style="font-size: 12px">Favorite</div>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center">
          <div class="row justify-content-center" v-show="Booth_Design == 'A6'">
            <div class="A6">
              <div class="text-center mb-2 mt-4" style="font-size: 18px">
                Preview of booth display
              </div>
              <div class="MbExhType homesection">
                <div class="Booth_MbTop">
                  <div class="MbLogobanner row align-items-center">
                    <div class="col-3">
                      <div class="MblogImgFrame">
                        <img
                          :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                          alt=""
                          width="60%"
                        />
                      </div>
                    </div>
                    <div class="col-9">
                      <div class="LogoText">
                        {{ OnlineExpoProfile.MemberComName }}
                      </div>
                    </div>
                  </div>

                  <div v-show="hasCard">
                    <span
                      class="TopicMbA6_dotCard pointer"
                      @click="openInquiryModal"
                      ><i class="far fa-dot-circle MbIconSize"></i>
                      <div class="TopicMbA6_staffArea"></div>
                    </span>
                  </div>

                  <div v-show="!hasCard">
                    <a
                      :href="`onlineExpoCardInfo?no=${RegNo}`"
                      data-fancybox
                      data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                      data-type="iframe"
                      class="iframeFormCard AddRegLink"
                    >
                      <span class="TopicMbA6_dotCard pointer"
                        ><i class="far fa-dot-circle MbIconSize"></i>
                        <div class="TopicMbA6_staffArea"></div>
                      </span>
                    </a>
                  </div>
                  <img src="@/assets/images/Expo_TopicA6.png" width="320px" />
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img
                      :src="ExpoM_Banner1"
                      class="mTopicA6_Banner01 BannerHover img-thumbnailA6M"
                    />
                    <span class="TopicMbA6_dot1"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>
                  </a>

                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img
                      :src="ExpoM_Banner2"
                      class="mTopicA6_Banner02 BannerHover img-thumbnailA6M"
                    />
                    <span class="TopicMbA6_dot2"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>
                  </a>

                  <span v-if="ExpovideoLink">
                    <a
                      :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      data-fancybox
                      data-width="640"
                      data-height="360"
                    >
                      <img
                        :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                        class="mTopicA6_Video BannerHover"
                      />
                      <span class="TopicMbA6_Video"
                        ><i class="far fa-dot-circle MbIconSize"></i
                      ></span>
                    </a>
                  </span>

                  <span
                    v-else-if="videoLink_Youku"
                    class="mTopicA6_Video"
                    style="background-color: #dfdfdfd9"
                  >
                    <a
                      :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                      data-fancybox
                      data-type="iframe"
                      data-width="640"
                      data-height="360"
                    >
                      <div
                        class="insideUK"
                        style="color: #5e5e5ecc; margin-top: 1px"
                      >
                        <i class="fas fa-play-circle"></i>
                      </div>
                    </a>
                  </span>

                  <span v-else>
                    <img
                      src="@/assets/images/default_video.jpg"
                      class="mTopicA6_Video BannerHover"
                    />
                  </span>
                </div>
                <div class="Mbfooter">
                  <div class="d-flex justify-content-around mt-3">
                    <div>
                      <div
                        class="text-center pointer iconOpenHover"
                        @click="openUserModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_profile.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Profile</div>
                      </div>
                      <div
                        class="text-center pointer iconOpenHover mt-3"
                        @click="openProductModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_products.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Products</div>
                      </div>
                    </div>
                    <div>
                      <div
                        class="text-center pointer iconOpenHover"
                        @click="openVideoModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_video.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Videos</div>
                      </div>

                      <div
                        class="text-center pointer iconOpenHover mt-3"
                        @click="openNewsModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_news.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Press Release</div>
                      </div>
                    </div>

                    <div>
                      <div
                        class="text-center pointer iconOpenHover"
                        @click="openInquiryModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_chat.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Inquiry</div>
                      </div>

                      <div class="pointer iconOpenHover mt-3">
                        <span>
                          <div class="text-center pointer iconOpenHover">
                            <img
                              src="@/assets/images/onlineExpo_favorite.png"
                              width="20px"
                              alt=""
                            />

                            <div style="font-size: 12px">Favorite</div>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center">
          <div class="row justify-content-center" v-show="Booth_Design == 'B1'">
            <div class="B1">
              <div class="text-center mb-2 mt-4" style="font-size: 18px">
                Preview of booth display
              </div>
              <div class="MbExhType homesection">
                <div class="Booth_MbTop">
                  <div class="MbLogobanner row align-items-center">
                    <div class="col-3">
                      <div class="MblogImgFrame">
                        <img
                          :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                          alt=""
                          width="60%"
                        />
                      </div>
                    </div>
                    <div class="col-9">
                      <div class="LogoText">
                        {{ OnlineExpoProfile.MemberComName }}
                      </div>
                    </div>
                  </div>

                  <div v-show="hasCard">
                    <span
                      class="TopicMbB1_dotCard pointer"
                      @click="openInquiryModal"
                      ><i class="far fa-dot-circle MbIconSize"></i>
                      <div class="TopicMbB1_staffArea"></div>
                    </span>
                  </div>

                  <div v-show="!hasCard">
                    <a
                      :href="`onlineExpoCardInfo?no=${RegNo}`"
                      data-fancybox
                      data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                      data-type="iframe"
                      class="iframeFormCard AddRegLink"
                    >
                      <span class="TopicMbB1_dotCard pointer"
                        ><i class="far fa-dot-circle MbIconSize"></i>
                        <div class="TopicMbB1_staffArea"></div>
                      </span>
                    </a>
                  </div>

                  <img src="@/assets/images/Expo_Topic3.png" width="320px" />
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <span class="TopicMbB1_dot1"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>

                    <img
                      :src="ExpoM_Banner1"
                      class="mTopicB1_Banner01 BannerHover"
                    />
                  </a>
                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img
                      :src="ExpoM_Banner2"
                      class="mTopicB1_Banner02 BannerHover"
                    />
                    <span class="TopicMbB1_dot2"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>
                  </a>
                  <a :href="ExpoL_Banner3" data-fancybox>
                    <img
                      :src="ExpoM_Banner3"
                      class="mTopicB1_Banner03 BannerHover"
                    />
                    <span class="TopicMbB1_dot3"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>
                  </a>
                  <a :href="ExpoL_Banner4" data-fancybox>
                    <img
                      :src="ExpoM_Banner4"
                      class="mTopicB1_Banner04 BannerHover"
                    />
                    <span class="TopicMbB1_dot4"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>
                  </a>

                  <span v-if="ExpovideoLink">
                    <a
                      :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      data-fancybox
                      data-width="640"
                      data-height="360"
                    >
                      <img
                        :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                        class="mTopicB1_Video BannerHover"
                      />

                      <span class="TopicMbB1_Video"
                        ><i class="far fa-dot-circle MbIconSize"></i
                      ></span>
                    </a>
                  </span>

                  <span
                    v-else-if="videoLink_Youku"
                    class="mTopicB1_Video"
                    style="background-color: #dfdfdfd9"
                  >
                    <a
                      :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                      data-fancybox
                      data-type="iframe"
                      data-width="640"
                      data-height="360"
                    >
                      <div
                        class="insideUK"
                        style="color: #5e5e5ecc; margin-top: 1px"
                      >
                        <i class="fas fa-play-circle"></i>
                      </div>
                    </a>
                  </span>

                  <span v-else>
                    <img
                      src="@/assets/images/default_video.jpg"
                      class="mTopicB1_Video BannerHover"
                    />
                  </span>
                </div>
                <div class="Mbfooter">
                  <div class="d-flex justify-content-around mt-3">
                    <div>
                      <div
                        class="text-center pointer iconOpenHover"
                        @click="openUserModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_profile.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Profile</div>
                      </div>
                      <div
                        class="text-center pointer iconOpenHover mt-3"
                        @click="openProductModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_products.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Products</div>
                      </div>
                    </div>
                    <div>
                      <div
                        class="text-center pointer iconOpenHover"
                        @click="openVideoModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_video.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Videos</div>
                      </div>

                      <div
                        class="text-center pointer iconOpenHover mt-3"
                        @click="openNewsModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_news.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Press Release</div>
                      </div>
                    </div>

                    <div>
                      <div
                        class="text-center pointer iconOpenHover"
                        @click="openInquiryModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_chat.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Inquiry</div>
                      </div>

                      <div class="pointer iconOpenHover mt-3">
                        <span>
                          <div class="text-center pointer iconOpenHover">
                            <img
                              src="@/assets/images/onlineExpo_favorite.png"
                              width="20px"
                              alt=""
                            />

                            <div style="font-size: 12px">Favorite</div>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center">
          <div class="row justify-content-center" v-show="Booth_Design == 'B2'">
            <div class="B2">
              <div class="text-center mb-2 mt-4" style="font-size: 18px">
                Preview of booth display
              </div>
              <div class="MbExhType homesection">
                <div class="Booth_MbTop">
                  <div class="MbLogobanner row align-items-center">
                    <div class="col-3">
                      <div class="MblogImgFrame">
                        <img
                          :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                          alt=""
                          width="60%"
                        />
                      </div>
                    </div>
                    <div class="col-9">
                      <div class="LogoText">
                        {{ OnlineExpoProfile.MemberComName }}
                      </div>
                    </div>
                  </div>

                  <div v-show="hasCard">
                    <span
                      class="TopicMbB2_dotCard pointer"
                      @click="openInquiryModal"
                      ><i class="far fa-dot-circle MbIconSize"></i>
                      <div class="TopicMbB2_staffArea"></div>
                    </span>
                  </div>

                  <div v-show="!hasCard">
                    <a
                      :href="`onlineExpoCardInfo?no=${RegNo}`"
                      data-fancybox
                      data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                      data-type="iframe"
                      class="iframeFormCard AddRegLink"
                    >
                      <span class="TopicMbB2_dotCard pointer"
                        ><i class="far fa-dot-circle MbIconSize"></i>
                        <div class="TopicMbB2_staffArea"></div>
                      </span>
                    </a>
                  </div>
                  <img src="@/assets/images/Expo_Topic4.png" width="320px" />
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img
                      :src="ExpoM_Banner1"
                      class="mTopicB2_Banner01 BannerHover"
                    />
                    <span class="TopicMbB2_dot1"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>
                  </a>
                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img
                      :src="ExpoM_Banner2"
                      class="mTopicB2_Banner02 BannerHover"
                    />
                    <span class="TopicMbB2_dot2"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>
                  </a>
                  <a :href="ExpoL_Banner3" data-fancybox>
                    <img
                      :src="ExpoM_Banner3"
                      class="mTopicB2_Banner03 BannerHover"
                    />
                    <span class="TopicMbB2_dot3"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>
                  </a>
                  <a :href="ExpoL_Banner4" data-fancybox>
                    <img
                      :src="ExpoM_Banner4"
                      class="mTopicB2_Banner04 BannerHover"
                    />
                    <span class="TopicMbB2_dot4"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>
                  </a>

                  <span v-if="ExpovideoLink">
                    <a
                      :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      data-fancybox
                      data-width="640"
                      data-height="360"
                    >
                      <img
                        :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                        class="mTopicB2_Video BannerHover"
                      />

                      <span class="TopicMbB2_Video"
                        ><i class="far fa-dot-circle MbIconSize"></i
                      ></span>
                    </a>
                  </span>

                  <span
                    v-else-if="videoLink_Youku"
                    class="mTopicB2_Video"
                    style="background-color: #dfdfdfd9"
                  >
                    <a
                      :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                      data-fancybox
                      data-type="iframe"
                      data-width="640"
                      data-height="360"
                    >
                      <div
                        class="insideUK"
                        style="color: #5e5e5ecc; margin-top: 1px"
                      >
                        <i class="fas fa-play-circle"></i>
                      </div>
                    </a>
                  </span>

                  <span v-else>
                    <img
                      src="@/assets/images/default_video.jpg"
                      class="mTopicB2_Video BannerHover"
                    />
                  </span>
                </div>
                <div class="Mbfooter">
                  <div class="d-flex justify-content-around mt-3">
                    <div>
                      <div
                        class="text-center pointer iconOpenHover"
                        @click="openUserModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_profile.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Profile</div>
                      </div>
                      <div
                        class="text-center pointer iconOpenHover mt-3"
                        @click="openProductModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_products.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Products</div>
                      </div>
                    </div>
                    <div>
                      <div
                        class="text-center pointer iconOpenHover"
                        @click="openVideoModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_video.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Videos</div>
                      </div>

                      <div
                        class="text-center pointer iconOpenHover mt-3"
                        @click="openNewsModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_news.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Press Release</div>
                      </div>
                    </div>

                    <div>
                      <div
                        class="text-center pointer iconOpenHover"
                        @click="openInquiryModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_chat.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Inquiry</div>
                      </div>

                      <div class="pointer iconOpenHover mt-3">
                        <span>
                          <div class="text-center pointer iconOpenHover">
                            <img
                              src="@/assets/images/onlineExpo_favorite.png"
                              width="20px"
                              alt=""
                            />

                            <div style="font-size: 12px">Favorite</div>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center">
          <div class="row justify-content-center" v-show="Booth_Design == 'B3'">
            <div class="B3">
              <div class="text-center mb-2 mt-4" style="font-size: 18px">
                Preview of booth display
              </div>
              <div class="MbExhType homesection">
                <div class="Booth_MbTop">
                  <div class="MbLogobanner row align-items-center">
                    <div class="col-3">
                      <div class="MblogImgFrame">
                        <img
                          :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                          alt=""
                          width="60%"
                        />
                      </div>
                    </div>
                    <div class="col-9">
                      <div class="LogoText">
                        {{ OnlineExpoProfile.MemberComName }}
                      </div>
                    </div>
                  </div>

                  <div v-show="hasCard">
                    <span
                      class="TopicMbB3_dotCard pointer"
                      @click="openInquiryModal"
                      ><i class="far fa-dot-circle MbIconSize"></i>
                      <div class="TopicMbB3_staffArea"></div>
                    </span>
                  </div>

                  <div v-show="!hasCard">
                    <a
                      :href="`onlineExpoCardInfo?no=${RegNo}`"
                      data-fancybox
                      data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                      data-type="iframe"
                      class="iframeFormCard AddRegLink"
                    >
                      <span class="TopicMbB3_dotCard pointer"
                        ><i class="far fa-dot-circle MbIconSize"></i>
                        <div class="TopicMbB3_staffArea"></div>
                      </span>
                    </a>
                  </div>
                  <img src="@/assets/images/Expo_Topic5.png" width="320px" />
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img
                      :src="ExpoM_Banner1"
                      class="mTopicB3_Banner01 BannerHover"
                    />
                    <span class="TopicMbB3_dot1"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>
                  </a>
                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img
                      :src="ExpoM_Banner2"
                      class="mTopicB3_Banner02 BannerHover"
                    />
                    <span class="TopicMbB3_dot2"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>
                  </a>
                  <a :href="ExpoL_Banner3" data-fancybox>
                    <img
                      :src="ExpoM_Banner3"
                      class="mTopicB3_Banner03 BannerHover"
                    />
                    <span class="TopicMbB3_dot3"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>
                  </a>
                  <a :href="ExpoL_Banner4" data-fancybox>
                    <img
                      :src="ExpoM_Banner4"
                      class="mTopicB3_Banner04 BannerHover"
                    />
                    <span class="TopicMbB3_dot4"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>
                  </a>

                  <span v-if="ExpovideoLink">
                    <a
                      :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      data-fancybox
                      data-width="640"
                      data-height="360"
                    >
                      <img
                        :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                        class="mTopicB3_Video BannerHover"
                      />

                      <span class="TopicMbB3_Video"
                        ><i class="far fa-dot-circle MbIconSize"></i
                      ></span>
                    </a>
                  </span>

                  <span
                    v-else-if="videoLink_Youku"
                    class="mTopicB3_Video"
                    style="background-color: #dfdfdfd9"
                  >
                    <a
                      :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                      data-fancybox
                      data-type="iframe"
                      data-width="640"
                      data-height="360"
                    >
                      <div
                        class="insideUK"
                        style="color: #5e5e5ecc; margin-top: 1px"
                      >
                        <i class="fas fa-play-circle"></i>
                      </div>
                    </a>
                  </span>

                  <span v-else>
                    <img
                      src="@/assets/images/default_video.jpg"
                      class="mTopicB3_Video BannerHover"
                    />
                  </span>
                </div>
                <div class="Mbfooter">
                  <div class="d-flex justify-content-around mt-3">
                    <div>
                      <div
                        class="text-center pointer iconOpenHover"
                        @click="openUserModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_profile.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Profile</div>
                      </div>
                      <div
                        class="text-center pointer iconOpenHover mt-3"
                        @click="openProductModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_products.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Products</div>
                      </div>
                    </div>
                    <div>
                      <div
                        class="text-center pointer iconOpenHover"
                        @click="openVideoModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_video.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Videos</div>
                      </div>

                      <div
                        class="text-center pointer iconOpenHover mt-3"
                        @click="openNewsModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_news.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Press Release</div>
                      </div>
                    </div>

                    <div>
                      <div
                        class="text-center pointer iconOpenHover"
                        @click="openInquiryModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_chat.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Inquiry</div>
                      </div>

                      <div class="pointer iconOpenHover mt-3">
                        <span>
                          <div class="text-center pointer iconOpenHover">
                            <img
                              src="@/assets/images/onlineExpo_favorite.png"
                              width="20px"
                              alt=""
                            />

                            <div style="font-size: 12px">Favorite</div>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center">
          <div class="row justify-content-center" v-show="Booth_Design == 'B4'">
            <div class="B4">
              <div class="text-center mb-2 mt-4" style="font-size: 18px">
                Preview of booth display
              </div>
              <div class="MbExhType homesection">
                <div class="Booth_MbTop">
                  <div class="MbLogobanner row align-items-center">
                    <div class="col-3">
                      <div class="MblogImgFrame">
                        <img
                          :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                          alt=""
                          width="60%"
                        />
                      </div>
                    </div>
                    <div class="col-9">
                      <div class="LogoText">
                        {{ OnlineExpoProfile.MemberComName }}
                      </div>
                    </div>
                  </div>

                  <div v-show="hasCard">
                    <span
                      class="TopicMbB4_dotCard pointer"
                      @click="openInquiryModal"
                      ><i class="far fa-dot-circle MbIconSize"></i>
                      <div class="TopicMbB4_staffArea"></div>
                    </span>
                  </div>

                  <div v-show="!hasCard">
                    <a
                      :href="`onlineExpoCardInfo?no=${RegNo}`"
                      data-fancybox
                      data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                      data-type="iframe"
                      class="iframeFormCard AddRegLink"
                    >
                      <span class="TopicMbB4_dotCard pointer"
                        ><i class="far fa-dot-circle MbIconSize"></i>
                        <div class="TopicMbB4_staffArea"></div>
                      </span>
                    </a>
                  </div>
                  <img src="@/assets/images/Expo_Topic6.png" width="320px" />
                  <a :href="ExpoL_Banner1" data-fancybox>
                    <img
                      :src="ExpoM_Banner1"
                      class="mTopicB4_Banner01 BannerHover"
                    />
                    <span class="TopicMbB4_dot1"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>
                  </a>
                  <a :href="ExpoL_Banner2" data-fancybox>
                    <img
                      :src="ExpoM_Banner2"
                      class="mTopicB4_Banner02 BannerHover"
                    />
                    <span class="TopicMbB4_dot2"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>
                  </a>
                  <a :href="ExpoL_Banner3" data-fancybox>
                    <img
                      :src="ExpoM_Banner3"
                      class="mTopicB4_Banner03 BannerHover"
                    />
                    <span class="TopicMbB4_dot3"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>
                  </a>
                  <a :href="ExpoL_Banner4" data-fancybox>
                    <img
                      :src="ExpoM_Banner4"
                      class="mTopicB4_Banner04 BannerHover"
                    />
                    <span class="TopicMbB4_dot4"
                      ><i class="far fa-dot-circle MbIconSize"></i
                    ></span>
                  </a>

                  <span v-if="ExpovideoLink">
                    <a
                      :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      data-fancybox
                      data-width="640"
                      data-height="360"
                    >
                      <img
                        :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                        class="mTopicB4_Video BannerHover"
                      />

                      <span class="TopicMbB4_Video"
                        ><i class="far fa-dot-circle MbIconSize"></i
                      ></span>
                    </a>
                  </span>

                  <span
                    v-else-if="videoLink_Youku"
                    class="mTopicB4_Video"
                    style="background-color: #dfdfdfd9"
                  >
                    <a
                      :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                      data-fancybox
                      data-type="iframe"
                      data-width="640"
                      data-height="360"
                    >
                      <div
                        class="insideUK"
                        style="color: #5e5e5ecc; margin-top: 1px"
                      >
                        <i class="fas fa-play-circle"></i>
                      </div>
                    </a>
                  </span>

                  <span v-else>
                    <img
                      src="@/assets/images/default_video.jpg"
                      class="mTopicB4_Video BannerHover"
                    />
                  </span>
                </div>

                <div class="Mbfooter">
                  <div class="d-flex justify-content-around mt-3">
                    <div>
                      <div
                        class="text-center pointer iconOpenHover"
                        @click="openUserModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_profile.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Profile</div>
                      </div>
                      <div
                        class="text-center pointer iconOpenHover mt-3"
                        @click="openProductModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_products.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Products</div>
                      </div>
                    </div>
                    <div>
                      <div
                        class="text-center pointer iconOpenHover"
                        @click="openVideoModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_video.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Videos</div>
                      </div>

                      <div
                        class="text-center pointer iconOpenHover mt-3"
                        @click="openNewsModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_news.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Press Release</div>
                      </div>
                    </div>

                    <div>
                      <div
                        class="text-center pointer iconOpenHover"
                        @click="openInquiryModal"
                      >
                        <img
                          src="@/assets/images/onlineExpo_chat.png"
                          width="20px"
                          alt=""
                        />
                        <div style="font-size: 12px">Inquiry</div>
                      </div>

                      <div class="pointer iconOpenHover mt-3">
                        <span>
                          <div class="text-center pointer iconOpenHover">
                            <img
                              src="@/assets/images/onlineExpo_favorite.png"
                              width="20px"
                              alt=""
                            />

                            <div style="font-size: 12px">Favorite</div>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p
          class="border rounded p-3"
          style="font-size: 12px"
          v-if="showOnlineExhLink"
        >
          Online exhibition booth URL：<br /><span
            style="word-break: break-all; width: 150px"
            >{{ ExhibitorWebsite }}</span
          ><br /><br />
          This URL can be provided to invite customers to visit your online
          booth. Please be aware that this URL is only available during the
          opening hours of the online exhibition.
          <span class="text-muted" style="font-size: 10px"
            >Remarks：The visitors must complete the registration process before
            visiting the online exhibition.
          </span>
        </p>

        <div class="mt-3">
          <section
            id="advantage-head-section"
            class="pb-3 text-center text-dark"
          >
            <div class="container">
              <div class="row">
                <div class="col">
                  <div id="accordion">
                    <div class="card">
                      <div class="card-header">
                        <div class="mb-0">
                          <div
                            data-toggle="collapse"
                            data-parent="#accordion"
                            aria-expanded="true"
                            style="font-size: 15px"
                          >
                            <div
                              class="d-flex align-items-center justify-content-center"
                            >
                              <div
                                class="complete mr-1"
                                v-if="hasExpoTopic"
                              ></div>
                              <div class="uncomplete mr-1" v-else></div>
                              <div>Booth Type</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="collapse show" data-parent="#accordion">
                        <div class="card-body">
                          <p class="mb-3">Choose one booth type</p>

                          <a
                            :href="`onlineExpoBooth?no=${RegNo}`"
                            data-fancybox
                            data-type="iframe"
                            class="iframeForm AddRegLink"
                          >
                            <div
                              class="d-flex align-items-center justify-content-center"
                            >
                              <div class="btn btn-outline-secondary btn-sm">
                                Edit
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>

                    <div class="card AddGrayFrame">
                      <div class="card-header">
                        <div class="mb-0">
                          <div
                            data-toggle="collapse"
                            data-parent="#accordion"
                            aria-expanded="true"
                            style="font-size: 15px"
                          >
                            <div
                              class="d-flex align-items-center justify-content-center"
                            >
                              <span
                                class="complete mr-1"
                                v-if="hasAllBanner"
                              ></span>
                              <span class="uncomplete mr-1" v-else></span>
                              <div>Corporate Poster</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="collapse show" data-parent="#accordion">
                        <div class="card-body">
                          <div v-if="isVip">
                            <p class="mb-3">
                              Please upload four designs ( Note: The display of
                              your upload will go from left to right )
                            </p>
                            <div
                              class="d-flex align-items-center justify-content-center"
                            >
                              <div class="text-left mt-2">
                                <div class="mb-3">
                                  <span
                                    v-if="
                                      ExpoM_Banner1 ==
                                        '@/assets/images/default_230x450.jpg' ||
                                      !ExpoM_Banner1
                                    "
                                  >
                                    <i
                                      class="fas fa-check-circle mr-1"
                                      style="color: rgb(197, 194, 194)"
                                    ></i>
                                  </span>
                                  <span v-else>
                                    <i
                                      class="fas fa-check-circle mr-1 text-success"
                                    ></i>
                                  </span>
                                  Left
                                </div>
                                <div class="mb-3">
                                  <span
                                    v-if="
                                      ExpoM_Banner2 ==
                                        '@/assets/images/default_230x450.jpg' ||
                                      !ExpoM_Banner2
                                    "
                                  >
                                    <i
                                      class="fas fa-check-circle mr-1"
                                      style="color: rgb(197, 194, 194)"
                                    ></i>
                                  </span>
                                  <span v-else>
                                    <i
                                      class="fas fa-check-circle mr-1 text-success"
                                    ></i>
                                  </span>
                                  Left-center
                                </div>
                                <div class="mb-3">
                                  <span
                                    v-if="
                                      ExpoM_Banner3 ==
                                        '@/assets/images/default_230x450.jpg' ||
                                      !ExpoM_Banner3
                                    "
                                  >
                                    <i
                                      class="fas fa-check-circle mr-1"
                                      style="color: rgb(197, 194, 194)"
                                    ></i>
                                  </span>
                                  <span v-else>
                                    <i
                                      class="fas fa-check-circle mr-1 text-success"
                                    ></i>
                                  </span>
                                  Right-center
                                </div>
                                <div class="mb-3">
                                  <span
                                    v-if="
                                      ExpoM_Banner4 ==
                                        '@/assets/images/default_230x450.jpg' ||
                                      !ExpoM_Banner4
                                    "
                                  >
                                    <i
                                      class="fas fa-check-circle mr-1"
                                      style="color: rgb(197, 194, 194)"
                                    ></i>
                                  </span>
                                  <span v-else>
                                    <i
                                      class="fas fa-check-circle mr-1 text-success"
                                    ></i>
                                  </span>
                                  Right
                                </div>
                              </div>
                              <div>
                                <div class="mb-1">
                                  <a
                                    :href="`onlineExpoBanner1?no=${RegNo}`"
                                    data-fancybox
                                    data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                                    data-type="iframe"
                                    class="linkdisable iframeForm AddRegLink btn btn-outline-secondary btn-sm ml-4"
                                    >Edit
                                  </a>
                                </div>
                                <div class="mb-1">
                                  <a
                                    :href="`onlineExpoBanner2?no=${RegNo}`"
                                    data-fancybox
                                    data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                                    data-type="iframe"
                                    class="linkdisable iframeForm AddRegLink btn btn-outline-secondary btn-sm ml-4"
                                    >Edit
                                  </a>
                                </div>
                                <div class="mb-1">
                                  <a
                                    :href="`onlineExpoBanner3?no=${RegNo}`"
                                    data-fancybox
                                    data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                                    data-type="iframe"
                                    class="linkdisable iframeForm AddRegLink btn btn-outline-secondary btn-sm ml-4"
                                    >Edit
                                  </a>
                                </div>
                                <div class="mb-1">
                                  <a
                                    :href="`onlineExpoBanner4?no=${RegNo}`"
                                    data-fancybox
                                    data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                                    data-type="iframe"
                                    class="linkdisable iframeForm AddRegLink btn btn-outline-secondary btn-sm ml-4"
                                    >Edit
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div v-if="!isVip">
                            <p class="mb-3">
                              Please upload two designs ( Note: The display of
                              your upload will go from left to right )
                            </p>
                            <div
                              class="d-flex align-items-center justify-content-center"
                            >
                              <div class="text-left mt-2">
                                <div class="mb-3">
                                  <span
                                    v-if="
                                      ExpoM_Banner1 ==
                                        '@/assets/images/default_230x450.jpg' ||
                                      !ExpoM_Banner1
                                    "
                                  >
                                    <i
                                      class="fas fa-check-circle mr-1"
                                      style="color: rgb(197, 194, 194)"
                                    ></i>
                                  </span>
                                  <span v-else>
                                    <i
                                      class="fas fa-check-circle mr-1 text-success"
                                    ></i>
                                  </span>
                                  Left
                                </div>
                                <div class="mb-3">
                                  <span
                                    v-if="
                                      ExpoM_Banner2 ==
                                        '@/assets/images/default_230x450.jpg' ||
                                      !ExpoM_Banner2
                                    "
                                  >
                                    <i
                                      class="fas fa-check-circle mr-1"
                                      style="color: rgb(197, 194, 194)"
                                    ></i>
                                  </span>
                                  <span v-else>
                                    <i
                                      class="fas fa-check-circle mr-1 text-success"
                                    ></i>
                                  </span>
                                  Right
                                </div>
                              </div>
                              <div>
                                <div class="mb-1">
                                  <a
                                    :href="`onlineExpoBanner1?no=${RegNo}`"
                                    data-fancybox
                                    data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                                    data-type="iframe"
                                    class="linkdisable iframeForm AddRegLink btn btn-outline-secondary btn-sm ml-4"
                                    >Edit
                                  </a>
                                </div>
                                <div class="mb-1">
                                  <a
                                    :href="`onlineExpoBanner2?no=${RegNo}`"
                                    data-fancybox
                                    data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                                    data-type="iframe"
                                    class="linkdisable iframeForm AddRegLink btn btn-outline-secondary btn-sm ml-4"
                                    >Edit
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card AddGrayFrame">
                      <div class="card-header">
                        <div class="mb-0">
                          <div
                            data-toggle="collapse"
                            data-parent="#accordion"
                            aria-expanded="false"
                            style="font-size: 15px"
                          >
                            <div
                              class="d-flex align-items-center justify-content-center"
                            >
                              <div
                                class="complete mr-1"
                                v-if="hasExpoVideo"
                              ></div>
                              <div class="uncomplete mr-1" v-else></div>
                              <div>Corporate Video</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="collapse show" data-parent="#accordion">
                        <div class="card-body">
                          <p class="mb-3">Choose the video at the booth</p>
                          <div
                            class="d-flex align-items-center justify-content-center"
                          >
                            <a
                              :href="`onlineExpoVideoList?no=${RegNo}`"
                              data-fancybox
                              data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                              data-type="iframe"
                              class="iframeForm AddRegLink linkdisable"
                            >
                              <div class="btn btn-outline-secondary btn-sm">
                                Edit
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="card AddGrayFrame">
                    <div class="card-header">
                      <div class="mb-0">
                        <div
                          data-toggle="collapse"
                          data-parent="#accordion"
                          aria-expanded="false"
                          style="font-size: 15px"
                        >
                          <div class="d-flex align-items-center justify-content-center">
                            <div class="complete mr-1" v-if="hasCard"></div>
                            <div class="uncomplete mr-1" v-else></div>
                            <div>e-business Card</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="collapse show" data-parent="#accordion">
                      <div class="card-body">
                        <p class="mb-3">New e-business card added</p>
                        <div class="d-flex align-items-center justify-content-center">
                          <a
                            :href="`onlineExpoCardInfo?no=${RegNo}`"
                            data-fancybox
                            data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                            data-type="iframe"
                            class="iframeFormCard AddRegLink linkdisable"
                          >
                            <div class="btn btn-outline-secondary btn-sm">Edit</div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <!-- pc版 -->
      <div class="PcDevice">
        <div class="contentBoxStatus">
          <p class="mb-3 text-center" style="font-size: 15px">
            Please upload the complete information for the following items to
            ensure the visitors understand your company, products, and services
            clearly
          </p>

          <div
            class="mb-4 border text-center py-2"
            style="
              font-size: 15px;
              margin-right: 17%;
              margin-left: 17%;
              border-radius: 30px;
            "
          >
            <div class="d-flex justify-content-around">
              <a :href="`profile?no=${RegNo}`">
                <div class="d-flex align-items-center">
                  <span
                    v-if="BasicinformationStatus == 1"
                    class="complete mr-1"
                  ></span>
                  <span v-else class="uncomplete mr-1"></span>
                  <span style="color: black">Information </span>
                </div>
              </a>

              <a :href="`product?no=${RegNo}`">
                <div class="d-flex align-items-center">
                  <span v-if="ProductStatus !== 0" class="complete mr-1"></span>
                  <span v-else class="uncomplete mr-1"></span>
                  <span class="border-dark text-dark">Products </span>
                </div>
              </a>

              <a :href="`news?no=${RegNo}`">
                <div class="d-flex align-items-center">
                  <span
                    v-if="PressReleaseStatus !== 0"
                    class="complete mr-1"
                  ></span>
                  <span v-else class="uncomplete mr-1"></span>
                  <span style="color: black">Press Release </span>
                </div>
              </a>

              <a :href="`video?no=${RegNo}`">
                <div class="d-flex align-items-center">
                  <span v-if="VideoStatus !== 0" class="complete mr-1"></span>
                  <span v-else class="uncomplete mr-1"></span>

                  <span style="color: black">Video </span>
                </div>
              </a>

              <span v-if="showOnlineStatus">
                <a :href="`onlineExpo?no=${RegNo}`">
                  <div class="d-flex align-items-center">
                    <span
                      v-if="OnlineExpolayoutStatus == 1"
                      class="complete mr-1"
                    ></span>
                    <span v-else class="uncomplete mr-1"></span>
                    <span style="color: black">Online Expo Settings </span>
                  </div>
                </a>
              </span>
            </div>
          </div>
        </div>

        <div class="my-3"></div>

        <div class="contentBox">
          <h1>Online Expo Settings</h1>
          <p class="my-3">&nbsp;</p>

          <div class="my-5 row text-center justify-content-center">
            <div class="col-2">
              <div class="card">
                <div class="card-header h5 font-weight-bold">
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="complete mr-1" v-if="hasExpoTopic"></div>
                    <div class="uncomplete mr-1" v-else></div>
                    <p>Booth Type</p>
                  </div>
                </div>
                <div class="card-body">
                  <p class="mb-3">Choose one booth type</p>
                  <hr />
                  <a
                    :href="`onlineExpoBooth?no=${RegNo}`"
                    data-fancybox
                    data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                    data-type="iframe"
                    class="iframeForm AddRegLink"
                  >
                    <div v-if="hasExpoTopic">
                      <img
                        src="@/assets/images/Expo_Topic1.png"
                        class="img-fluid pointer"
                        height="85"
                        v-if="Booth_Design == 'A1'"
                        width="151"
                      />
                      <img
                        src="@/assets/images/Expo_Topic2.png"
                        class="img-fluid pointer"
                        height="85"
                        v-if="Booth_Design == 'A2'"
                        width="151"
                      />

                      <img
                        src="@/assets/images/Expo_TopicA3.png"
                        class="img-fluid pointer"
                        height="85"
                        v-if="Booth_Design == 'A3'"
                        width="151"
                      />
                      <img
                        src="@/assets/images/Expo_TopicA4.png"
                        class="img-fluid pointer"
                        height="85"
                        v-if="Booth_Design == 'A4'"
                        width="151"
                      />
                      <img
                        src="@/assets/images/Expo_TopicA5.png"
                        class="img-fluid pointer"
                        height="85"
                        v-if="Booth_Design == 'A5'"
                        width="151"
                      />
                      <img
                        src="@/assets/images/Expo_TopicA6.png"
                        class="img-fluid pointer"
                        height="85"
                        v-if="Booth_Design == 'A6'"
                        width="151"
                      />

                      <img
                        src="@/assets/images/Expo_Topic3.png"
                        class="img-fluid pointer"
                        height="85"
                        v-if="Booth_Design == 'B1'"
                        width="151"
                      />
                      <img
                        src="@/assets/images/Expo_Topic4.png"
                        class="img-fluid pointer"
                        height="85"
                        v-if="Booth_Design == 'B2'"
                        width="151"
                      />
                      <img
                        src="@/assets/images/Expo_Topic5.png"
                        class="img-fluid pointer"
                        height="85"
                        v-if="Booth_Design == 'B3'"
                        width="151"
                      />
                      <img
                        src="@/assets/images/Expo_Topic6.png"
                        class="img-fluid pointer"
                        height="85"
                        v-if="Booth_Design == 'B4'"
                        width="151"
                      />
                    </div>
                    <div v-else>
                      <img
                        src="@/assets/images/default_sm_151x85.jpg"
                        class="img-fluid pointer"
                        height="85"
                        width="151"
                      />
                    </div>
                  </a>

                  <div>
                    <a
                      :href="`onlineExpoBooth?no=${RegNo}`"
                      data-fancybox
                      data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                      data-type="iframe"
                      class="iframeForm AddRegLink"
                    >
                      <div class="btn btn-outline-secondary mt-4">Edit</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-3" v-if="!isVip">
              <div class="card AddGrayFrame">
                <div class="card-header h5 font-weight-bold">
                  <div class="d-flex justify-content-center align-items-center">
                    <span class="complete mr-1" v-if="hasAllBanner"></span>
                    <span class="uncomplete mr-1" v-else></span>
                    <p>Corporate Poster</p>
                  </div>
                </div>
                <div class="card-body">
                  <p class="mb-3">
                    Please upload two designs ( Note: The display of your upload
                    will go from left to right )
                  </p>
                  <hr />
                  <div class="d-flex justify-content-around">
                    <div>
                      <a
                        :href="`onlineExpoBanner1?no=${RegNo}`"
                        data-fancybox
                        data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                        data-type="iframe"
                        class="linkdisable iframeForm AddRegLink"
                      >
                        <div class="imgFrameStyle">
                          <label class="inputFile">
                            <div
                              class="ImgHoverStyle pointer imgcenter d-flex align-items-center justify-content-center"
                            >
                              <span v-if="firstEntry">
                                <img
                                  src="@/assets/images/default_sm.jpg"
                                  width="40px"
                                  height="85px"
                                />
                              </span>
                              <span v-else>
                                <img
                                  :src="ExpoM_Banner1"
                                  width="40px"
                                  height="85px"
                                />
                              </span>
                            </div>
                          </label>
                        </div>
                      </a>
                      <div class="mt-3">
                        <a
                          :href="`onlineExpoBanner1?no=${RegNo}`"
                          data-fancybox
                          data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                          data-type="iframe"
                          class="linkdisable iframeForm AddRegLink"
                        >
                          <button class="btn btn-outline-secondary">
                            Edit
                          </button>
                        </a>
                      </div>
                    </div>
                    <div>
                      <a
                        :href="`onlineExpoBanner2?no=${RegNo}`"
                        data-fancybox
                        data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                        data-type="iframe"
                        class="linkdisable pointer iframeForm AddRegLink"
                      >
                        <div class="imgFrameStyle">
                          <label class="inputFile">
                            <div
                              class="ImgHoverStyle imgcenter d-flex align-items-center justify-content-center"
                            >
                              <span v-if="firstEntry">
                                <img
                                  src="@/assets/images/default_sm.jpg"
                                  width="40px"
                                  height="85px"
                                />
                              </span>
                              <span v-else>
                                <img
                                  :src="ExpoM_Banner2"
                                  width="40px"
                                  height="85px"
                                />
                              </span>
                            </div>
                          </label>
                        </div>
                      </a>
                      <div class="mt-3">
                        <a
                          :href="`onlineExpoBanner2?no=${RegNo}`"
                          data-fancybox
                          data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                          data-type="iframe"
                          class="linkdisable iframeForm AddRegLink"
                        >
                          <button class="btn btn-outline-secondary">
                            Edit
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-4" v-if="isVip">
              <div class="card AddGrayFrame">
                <div class="card-header h5 font-weight-bold">
                  <div class="d-flex justify-content-center align-items-center">
                    <span class="complete mr-1" v-if="hasAllBanner"></span>
                    <span class="uncomplete mr-1" v-else></span>
                    <p>Corporate Poster</p>
                  </div>
                </div>
                <div class="card-body">
                  <p class="mb-3">
                    Please upload four designs ( Note: The display of your
                    upload will go from left to right )
                  </p>
                  <hr />
                  <div class="d-flex justify-content-around">
                    <div>
                      <a
                        :href="`onlineExpoBanner1?no=${RegNo}`"
                        data-fancybox
                        data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                        data-type="iframe"
                        class="linkdisable iframeForm AddRegLink"
                      >
                        <div class="imgFrameStyle">
                          <label class="inputFile">
                            <div
                              class="ImgHoverStyle pointer imgcenter d-flex align-items-center justify-content-center"
                            >
                              <span v-if="firstEntry">
                                <img
                                  src="@/assets/images/default_sm.jpg"
                                  width="40px"
                                  height="85px"
                                />
                              </span>
                              <span v-else>
                                <img
                                  :src="ExpoM_Banner1"
                                  width="40px"
                                  height="85px"
                                />
                              </span>
                            </div>
                          </label>
                        </div>
                      </a>
                      <div class="mt-3">
                        <a
                          :href="`onlineExpoBanner1?no=${RegNo}`"
                          data-fancybox
                          data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                          data-type="iframe"
                          class="linkdisable iframeForm AddRegLink"
                        >
                          <div class="btn btn-outline-secondary">Edit</div>
                        </a>
                      </div>
                    </div>
                    <div>
                      <div class="imgFrameStyle">
                        <label class="inputFile">
                          <div
                            class="ImgHoverStyle imgcenter d-flex align-items-center justify-content-center"
                          >
                            <a
                              :href="`onlineExpoBanner2?no=${RegNo}`"
                              data-fancybox
                              data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                              data-type="iframe"
                              class="linkdisable pointer iframeForm AddRegLink"
                            >
                              <span v-if="firstEntry">
                                <img
                                  src="@/assets/images/default_sm.jpg"
                                  width="40px"
                                  height="85px"
                                />
                              </span>
                              <span v-else>
                                <img
                                  :src="ExpoM_Banner2"
                                  width="40px"
                                  height="85px"
                                />
                              </span>
                            </a>
                          </div>
                        </label>
                      </div>
                      <div class="mt-3">
                        <a
                          :href="`onlineExpoBanner2?no=${RegNo}`"
                          data-fancybox
                          data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                          data-type="iframe"
                          class="linkdisable iframeForm AddRegLink"
                        >
                          <div class="btn btn-outline-secondary">Edit</div>
                        </a>
                      </div>
                    </div>
                    <div>
                      <div class="imgFrameStyle">
                        <label class="inputFile">
                          <div
                            class="ImgHoverStyle pointer imgcenter d-flex align-items-center justify-content-center"
                          >
                            <a
                              :href="`onlineExpoBanner3?no=${RegNo}`"
                              data-fancybox
                              data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                              data-type="iframe"
                              class="linkdisable iframeForm AddRegLink"
                            >
                              <span v-if="firstEntry">
                                <img
                                  src="@/assets/images/default_sm.jpg"
                                  width="40px"
                                  height="85px"
                                />
                              </span>
                              <span v-else>
                                <img
                                  :src="ExpoM_Banner3"
                                  width="40px"
                                  height="85px"
                                />
                              </span>
                            </a>
                          </div>
                        </label>
                      </div>
                      <div class="mt-3">
                        <a
                          :href="`onlineExpoBanner3?no=${RegNo}`"
                          data-fancybox
                          data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                          data-type="iframe"
                          class="linkdisable iframeForm AddRegLink"
                        >
                          <div class="btn btn-outline-secondary">Edit</div>
                        </a>
                      </div>
                    </div>
                    <div>
                      <div class="imgFrameStyle">
                        <label class="inputFile">
                          <div
                            class="ImgHoverStyle pointer imgcenter d-flex align-items-center justify-content-center"
                          >
                            <a
                              :href="`onlineExpoBanner4?no=${RegNo}`"
                              data-fancybox
                              data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                              data-type="iframe"
                              class="linkdisable iframeForm AddRegLink"
                            >
                              <span v-if="firstEntry">
                                <img
                                  src="@/assets/images/default_sm.jpg"
                                  width="40px"
                                  height="85px"
                                />
                              </span>
                              <span v-else>
                                <img
                                  :src="ExpoM_Banner4"
                                  width="40px"
                                  height="85px"
                                />
                              </span>
                            </a>
                          </div>
                        </label>
                      </div>
                      <div class="mt-3">
                        <a
                          :href="`onlineExpoBanner4?no=${RegNo}`"
                          data-fancybox
                          data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                          data-type="iframe"
                          class="linkdisable iframeForm AddRegLink"
                        >
                          <div class="btn btn-outline-secondary">Edit</div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-2">
              <div class="card AddGrayFrame">
                <div class="card-header h5 font-weight-bold">
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="complete mr-1" v-if="hasExpoVideo"></div>
                    <div class="uncomplete mr-1" v-else></div>
                    <p>Corporate Video</p>
                  </div>
                </div>
                <div class="card-body">
                  <p class="mb-3">Choose the video at the booth</p>
                  <hr />
                  <p class="my-2 d-none">
                    <i
                      class="fas fa-check-circle my-2"
                      style="color: rgb(189, 192, 184)"
                    ></i>
                  </p>
                  <a
                    :href="`onlineExpoVideoList?no=${RegNo}`"
                    data-fancybox
                    data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                    data-type="iframe"
                    class="linkdisable iframeForm AddRegLink"
                  >
                    <span v-if="ExpovideoLink">
                      <img
                        :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                        class="img-fluid"
                        height="85"
                        width="151"
                      />
                    </span>

                    <span v-else-if="videoLink_Youku" class="topUK">
                      <iframe
                        width="151px"
                        height="85px"
                        :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                        frameborder="0"
                      >
                      </iframe>

                      <div class="insideUK"></div>
                    </span>
                    <span v-else>
                      <img
                        src="@/assets/images/default_video__151x85.jpg"
                        class="img-fluid"
                        height="85"
                        width="151"
                      />
                    </span>
                  </a>
                  <div class="mt-4">
                    <a
                      :href="`onlineExpoVideoList?no=${RegNo}`"
                      data-fancybox
                      data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                      data-type="iframe"
                      class="linkdisable iframeForm AddRegLink"
                    >
                      <button class="btn btn-outline-secondary">Edit</button>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="col-2">
              <div class="card AddGrayFrame">
                <div class="card-header h5 font-weight-bold">
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="complete mr-1" v-if="hasCard"></div>
                    <div class="uncomplete mr-1" v-else></div>
                    <p>e-business Card</p>
                  </div>
                </div>
                <div class="card-body">
                  <div class="mb-3">New e-business card added</div>
                  <hr />

                  <div class="my-2 d-none">
                    <i class="fas fa-check-circle my-2" style="color: rgb(189, 192, 184)"></i>
                  </div>
                  <a
                    :href="`onlineExpoCardInfo?no=${RegNo}`"
                    data-fancybox
                    data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                    data-type="iframe"
                    class="linkdisable iframeFormCard AddRegLink"
                  >
                    <img src="@/assets/images/businessCard.png" height="85" />
                  </a>

                  <div class="mt-4">
                    <a
                      :href="`onlineExpoCardInfo?no=${RegNo}`"
                      data-fancybox
                      data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                      data-type="iframe"
                      class="linkdisable iframeFormCard AddRegLink"
                    >
                      <button class="btn btn-outline-secondary">Edit</button>
                    </a>
                  </div>
                </div>
              </div>
            </div> -->
          </div>

          <div class="container" v-if="hasExpoTopic">
            <div class="h3 mb-3 text-center">Preview of booth display</div>

            <div
              class="mb-4 border rounded p-3"
              style="font-size: 14px; margin-right: 10%; margin-left: 10%"
              v-if="showOnlineExhLink"
            >
              Online exhibition booth URL：<span>{{ ExhibitorWebsite }}</span
              ><br /><br />
              This URL can be provided to invite customers to visit your online
              booth. Please be aware that this URL is only available during the
              opening hours of the online exhibition.
              <span class="text-muted" style="font-size: 12px"
                >Remarks：The visitors must complete the registration process
                before visiting the online exhibition.
              </span>
            </div>

            <div class="homesection">
              <div
                class="row justify-content-center"
                v-show="Booth_Design == 'A1'"
              >
                <div class="A1">
                  <div class="mb-0">
                    <div class="ExhType">
                      <div v-show="hasCard">
                        <span
                          class="TopicA1_dotCard pointer"
                          @click="openInquiryModal"
                          ><i class="far fa-dot-circle"></i>
                          <div class="TopicA1_staffArea"></div>
                        </span>
                      </div>

                      <a :href="ExpoL_Banner1" data-fancybox>
                        <img
                          :src="ExpoM_Banner1"
                          class="TopicA1_Banner01 BannerHover img-thumbnailA1"
                        />
                        <span class="TopicA1_dot1"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>

                      <a :href="ExpoL_Banner2" data-fancybox>
                        <img
                          :src="ExpoM_Banner2"
                          class="TopicA1_Banner02 BannerHover img-thumbnailA1"
                        />
                        <span class="TopicA1_dot2"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>

                      <span v-if="ExpovideoLink">
                        <a
                          :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                          frameborder="0"
                          allow="autoplay; encrypted-media"
                          data-fancybox
                          data-width="640"
                          data-height="360"
                        >
                          <img
                            :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                            class="TopicA1_Video BannerHover"
                          />

                          <span class="TopicA1_dotVideo"
                            ><i class="far fa-dot-circle"></i
                          ></span>
                        </a>
                      </span>

                      <span v-else-if="videoLink_Youku" class="TopicA1_Video">
                        <a
                          :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                          data-fancybox
                          data-type="iframe"
                          data-width="640"
                          data-height="360"
                          style="color: #434242"
                        >
                          <div class="topUK BannerHover">
                            <iframe
                              :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                              frameborder="0"
                              width="111px"
                              height="70px"
                            >
                            </iframe>

                            <div class="UKframe"></div>
                          </div>
                        </a>
                      </span>

                      <span v-else>
                        <img
                          src="@/assets/images/default_video.jpg"
                          class="TopicA1_Video BannerHover"
                        />
                      </span>

                      <img
                        src="@/assets/images/Expo_Topic1.png"
                        width="900px"
                      />

                      <div class="A1_Logobanner row align-items-center">
                        <div class="col-4">
                          <div class="logImgFrame">
                            <img
                              :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                              alt=""
                              width="70%"
                            />
                          </div>
                        </div>
                        <div class="col-8">
                          <div class="font-weight-bold" style="font-size: 12px">
                            {{ OnlineExpoProfile.MemberComName }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row justify-content-center"
                v-show="Booth_Design == 'A2'"
              >
                <div class="A2">
                  <div class="mb-0">
                    <div class="ExhType">
                      <div class="A2_Logobanner row align-items-center">
                        <div class="col-4">
                          <div class="logImgFrame">
                            <img
                              :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                              alt=""
                              width="70%"
                            />
                          </div>
                        </div>
                        <div class="col-8">
                          <div class="font-weight-bold" style="font-size: 12px">
                            {{ OnlineExpoProfile.MemberComName }}
                          </div>
                        </div>
                      </div>

                      <div v-show="hasCard">
                        <span
                          class="TopicA2_dotCard pointer"
                          @click="openInquiryModal"
                          ><i class="far fa-dot-circle"></i>
                          <div class="TopicA2_staffArea"></div>
                        </span>
                      </div>

                      <img
                        src="@/assets/images/Expo_Topic2.png"
                        width="900px"
                      />
                      <a :href="ExpoL_Banner1" data-fancybox>
                        <img
                          :src="ExpoM_Banner1"
                          class="TopicA2_Banner01 BannerHover"
                        />
                        <span class="TopicA2_dot1"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <a :href="ExpoL_Banner2" data-fancybox>
                        <img
                          :src="ExpoM_Banner2"
                          class="TopicA2_Banner02 BannerHover"
                        />
                        <span class="TopicA2_dot2"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <span v-if="ExpovideoLink">
                        <a
                          :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                          frameborder="0"
                          allow="autoplay; encrypted-media"
                          data-fancybox
                          data-width="640"
                          data-height="360"
                        >
                          <img
                            :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                            class="TopicA2_Video BannerHover"
                          />

                          <span class="TopicA2_dotVideo"
                            ><i class="far fa-dot-circle"></i
                          ></span>
                        </a>
                      </span>

                      <span v-else-if="videoLink_Youku" class="TopicA2_Video">
                        <a
                          :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                          data-fancybox
                          data-type="iframe"
                          data-width="640"
                          data-height="360"
                          style="color: #434242"
                        >
                          <div class="topUK BannerHover">
                            <iframe
                              :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                              frameborder="0"
                              width="107px"
                              height="63px"
                            >
                            </iframe>

                            <div class="UKframe"></div>
                          </div>
                        </a>
                      </span>

                      <span v-else>
                        <img
                          src="@/assets/images/default_video.jpg"
                          class="TopicA2_Video BannerHover"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row justify-content-center"
                v-show="Booth_Design == 'A3'"
              >
                <div class="A3">
                  <!-- <div class="h3 mb-4 text-center">Preview of booth display</div> -->
                  <div class="mb-0">
                    <div class="ExhType">
                      <div class="A3_Logobanner row align-items-center">
                        <div class="col-4">
                          <div class="logImgFrame">
                            <img
                              :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                              alt=""
                              width="70%"
                            />
                          </div>
                        </div>
                        <div class="col-8">
                          <div class="font-weight-bold" style="font-size: 12px">
                            {{ OnlineExpoProfile.MemberComName }}
                          </div>
                        </div>
                      </div>

                      <div v-show="hasCard">
                        <span
                          class="TopicA3_dotCard pointer"
                          @click="openInquiryModal"
                          ><i class="far fa-dot-circle"></i>
                          <div class="TopicA3_staffArea"></div>
                        </span>
                      </div>
                      <img
                        src="@/assets/images/Expo_TopicA3.png"
                        width="900px"
                      />
                      <a :href="ExpoL_Banner1" data-fancybox>
                        <img
                          :src="ExpoM_Banner1"
                          class="TopicA3_Banner01 BannerHover img-thumbnailA3"
                        />
                        <span class="TopicA3_dot1"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <a :href="ExpoL_Banner2" data-fancybox>
                        <img
                          :src="ExpoM_Banner2"
                          class="TopicA3_Banner02 BannerHover img-thumbnailA3"
                        />
                        <span class="TopicA3_dot2"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <span v-if="ExpovideoLink">
                        <a
                          :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                          frameborder="0"
                          allow="autoplay; encrypted-media"
                          data-fancybox
                          data-width="640"
                          data-height="360"
                        >
                          <img
                            :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                            class="TopicA3_Video BannerHover"
                          />

                          <span class="TopicA3_dotVideo"
                            ><i class="far fa-dot-circle"></i
                          ></span>
                        </a>
                      </span>

                      <span v-else-if="videoLink_Youku" class="TopicA3_Video">
                        <a
                          :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                          data-fancybox
                          data-type="iframe"
                          data-width="640"
                          data-height="360"
                          style="color: #434242"
                        >
                          <div class="topUK BannerHover">
                            <iframe
                              :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                              frameborder="0"
                              width="111px"
                              height="67px"
                            >
                            </iframe>

                            <div class="UKframe"></div>
                          </div>
                        </a>
                      </span>
                      <span v-else>
                        <img
                          src="@/assets/images/default_video.jpg"
                          class="TopicA3_Video BannerHover"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row justify-content-center"
                v-show="Booth_Design == 'A4'"
              >
                <div class="A4">
                  <!-- <div class="h3 mb-4 text-center">Preview of booth display</div> -->
                  <div class="mb-0">
                    <div class="ExhType">
                      <div class="A4_Logobanner row align-items-center">
                        <div class="col-4">
                          <div class="logImgFrame">
                            <img
                              :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                              alt=""
                              width="70%"
                            />
                          </div>
                        </div>
                        <div class="col-8">
                          <div class="font-weight-bold" style="font-size: 12px">
                            {{ OnlineExpoProfile.MemberComName }}
                          </div>
                        </div>
                      </div>

                      <div v-show="hasCard">
                        <span
                          class="TopicA4_dotCard pointer"
                          @click="openInquiryModal"
                          ><i class="far fa-dot-circle"></i>
                          <div class="TopicA4_staffArea"></div>
                        </span>
                      </div>
                      <img
                        src="@/assets/images/Expo_TopicA4.png"
                        width="900px"
                      />
                      <a :href="ExpoL_Banner1" data-fancybox>
                        <img
                          :src="ExpoM_Banner1"
                          class="TopicA4_Banner01 BannerHover img-thumbnailA4"
                        />
                        <span class="TopicA4_dot1"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <a :href="ExpoL_Banner2" data-fancybox>
                        <img
                          :src="ExpoM_Banner2"
                          class="TopicA4_Banner02 BannerHover img-thumbnailA4"
                        />
                        <span class="TopicA4_dot2"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <span v-if="ExpovideoLink">
                        <a
                          :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                          frameborder="0"
                          allow="autoplay; encrypted-media"
                          data-fancybox
                          data-width="640"
                          data-height="360"
                        >
                          <img
                            :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                            class="TopicA4_Video BannerHover"
                          />

                          <span class="TopicA4_dotVideo"
                            ><i class="far fa-dot-circle"></i
                          ></span>
                        </a>
                      </span>

                      <span v-else-if="videoLink_Youku" class="TopicA4_Video">
                        <a
                          :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                          data-fancybox
                          data-type="iframe"
                          data-width="640"
                          data-height="360"
                          style="color: #434242"
                        >
                          <div class="topUK BannerHover">
                            <iframe
                              :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                              frameborder="0"
                              width="116px"
                              height="77px"
                            >
                            </iframe>

                            <div class="UKframe"></div>
                          </div>
                        </a>
                      </span>
                      <span v-else>
                        <img
                          src="@/assets/images/default_video.jpg"
                          class="TopicA4_Video BannerHover"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row justify-content-center"
                v-show="Booth_Design == 'A5'"
              >
                <div class="A5">
                  <!-- <div class="h3 mb-4 text-center">Preview of booth display</div> -->
                  <div class="mb-0">
                    <div class="ExhType">
                      <div v-show="hasCard">
                        <span
                          class="TopicA5_dotCard pointer"
                          @click="openInquiryModal"
                          ><i class="far fa-dot-circle"></i>
                          <div class="TopicA5_staffArea"></div>
                        </span>
                      </div>

                      <div class="A5_Logobanner row align-items-center">
                        <div class="col-4">
                          <div class="logImgFrame">
                            <img
                              :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                              alt=""
                              width="70%"
                            />
                          </div>
                        </div>
                        <div class="col-8">
                          <div class="font-weight-bold" style="font-size: 12px">
                            {{ OnlineExpoProfile.MemberComName }}
                          </div>
                        </div>
                      </div>

                      <img
                        src="@/assets/images/Expo_TopicA5.png"
                        width="900px"
                      />
                      <a :href="ExpoL_Banner1" data-fancybox>
                        <img
                          :src="ExpoM_Banner1"
                          class="TopicA5_Banner01 BannerHover img-thumbnailA5"
                        />
                        <span class="TopicA5_dot1"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <a :href="ExpoL_Banner2" data-fancybox>
                        <img
                          :src="ExpoM_Banner2"
                          class="TopicA5_Banner02 BannerHover img-thumbnailA5"
                        />
                        <span class="TopicA5_dot2"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <span v-if="ExpovideoLink">
                        <a
                          :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                          frameborder="0"
                          allow="autoplay; encrypted-media"
                          data-fancybox
                          data-width="640"
                          data-height="360"
                        >
                          <img
                            :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                            class="TopicA5_Video BannerHover"
                          />

                          <span class="TopicA5_dotVideo"
                            ><i class="far fa-dot-circle"></i
                          ></span>
                        </a>
                      </span>

                      <span v-else-if="videoLink_Youku" class="TopicA5_Video">
                        <a
                          :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                          data-fancybox
                          data-type="iframe"
                          data-width="640"
                          data-height="360"
                          style="color: #434242"
                        >
                          <div class="topUK BannerHover">
                            <iframe
                              :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                              frameborder="0"
                              width="115px"
                              height="77px"
                            >
                            </iframe>

                            <div class="UKframe"></div>
                          </div>
                        </a>
                      </span>
                      <span v-else>
                        <img
                          src="@/assets/images/default_video.jpg"
                          class="TopicA5_Video BannerHover"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row justify-content-center"
                v-show="Booth_Design == 'A6'"
              >
                <div class="A6">
                  <div class="mb-0">
                    <div class="ExhType">
                      <div v-show="hasCard">
                        <span
                          class="TopicA6_dotCard pointer"
                          @click="openInquiryModal"
                          ><i class="far fa-dot-circle"></i>
                          <div class="TopicA6_staffArea"></div>
                        </span>
                      </div>

                      <div class="A6_Logobanner row align-items-center">
                        <div class="col-4">
                          <div class="logImgFrame">
                            <img
                              :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                              alt=""
                              width="70%"
                            />
                          </div>
                        </div>
                        <div class="col-8">
                          <div class="font-weight-bold" style="font-size: 12px">
                            {{ OnlineExpoProfile.MemberComName }}
                          </div>
                        </div>
                      </div>

                      <img
                        src="@/assets/images/Expo_TopicA6.png"
                        width="900px"
                      />
                      <a :href="ExpoL_Banner1" data-fancybox>
                        <img
                          :src="ExpoM_Banner1"
                          class="TopicA6_Banner01 BannerHover img-thumbnailA6"
                        />
                        <span class="TopicA6_dot1"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <a :href="ExpoL_Banner2" data-fancybox>
                        <img
                          :src="ExpoM_Banner2"
                          class="TopicA6_Banner02 BannerHover img-thumbnailA6"
                        />
                        <span class="TopicA6_dot2"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <span v-if="ExpovideoLink">
                        <a
                          :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                          frameborder="0"
                          allow="autoplay; encrypted-media"
                          data-fancybox
                          data-width="640"
                          data-height="360"
                        >
                          <img
                            :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                            class="TopicA6_Video BannerHover"
                          />

                          <span class="TopicA6_dotVideo"
                            ><i class="far fa-dot-circle"></i
                          ></span>
                        </a>
                      </span>

                      <span v-else-if="videoLink_Youku" class="TopicA6_Video">
                        <a
                          :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                          data-fancybox
                          data-type="iframe"
                          data-width="640"
                          data-height="360"
                          style="color: #434242"
                        >
                          <div class="topUK BannerHover">
                            <iframe
                              :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                              frameborder="0"
                              width="116px"
                              height="77px"
                            >
                            </iframe>

                            <div class="UKframe"></div>
                          </div>
                        </a>
                      </span>
                      <span v-else>
                        <img
                          src="@/assets/images/default_video.jpg"
                          class="TopicA6_Video BannerHover"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row justify-content-center"
                v-show="Booth_Design == 'B1'"
              >
                <div class="B1">
                  <!-- <div class="h3 mb-4 text-center">Preview of booth display</div> -->
                  <div class="mb-0">
                    <div class="ExhType">
                      <div v-show="hasCard">
                        <span
                          class="TopicB1_dotCard pointer"
                          @click="openInquiryModal"
                          ><i class="far fa-dot-circle"></i>
                          <div class="TopicB1_staffArea"></div>
                        </span>
                      </div>

                      <img
                        src="@/assets/images/Expo_Topic3.png"
                        width="900px"
                      />

                      <div class="B1_Logobanner row align-items-center">
                        <div class="col-4">
                          <div class="logImgFrame">
                            <img
                              :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                              alt=""
                              width="70%"
                            />
                          </div>
                        </div>
                        <div class="col-8">
                          <div class="font-weight-bold" style="font-size: 12px">
                            {{ OnlineExpoProfile.MemberComName }}
                          </div>
                        </div>
                      </div>

                      <a :href="ExpoL_Banner1" data-fancybox>
                        <img
                          :src="ExpoM_Banner1"
                          class="TopicB1_Banner01 BannerHover"
                        />
                        <span class="TopicB1_dot1"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <a :href="ExpoL_Banner2" data-fancybox>
                        <img
                          :src="ExpoM_Banner2"
                          class="TopicB1_Banner02 BannerHover"
                        />
                        <span class="TopicB1_dot2"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <a :href="ExpoL_Banner3" data-fancybox>
                        <img
                          :src="ExpoM_Banner3"
                          class="TopicB1_Banner03 BannerHover"
                        />
                        <span class="TopicB1_dot3"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <a :href="ExpoL_Banner4" data-fancybox>
                        <img
                          :src="ExpoM_Banner4"
                          class="TopicB1_Banner04 BannerHover"
                        />
                        <span class="TopicB1_dot4"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <span v-if="ExpovideoLink">
                        <a
                          :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                          frameborder="0"
                          allow="autoplay; encrypted-media"
                          data-fancybox
                          data-width="854"
                          data-height="480"
                        >
                          <img
                            :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                            class="TopicB1_Video BannerHover"
                          />

                          <span class="TopicB1_dotVideo"
                            ><i class="far fa-dot-circle"></i
                          ></span>
                        </a>
                      </span>

                      <span v-else-if="videoLink_Youku" class="TopicB1_Video">
                        <a
                          :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                          data-fancybox
                          data-type="iframe"
                          data-width="640"
                          data-height="360"
                          style="color: #434242"
                        >
                          <div class="topUK BannerHover">
                            <iframe
                              :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                              frameborder="0"
                              width="133px"
                              height="78px"
                            >
                            </iframe>

                            <div class="UKframe"></div>
                          </div>
                        </a>
                      </span>
                      <span v-else>
                        <img
                          src="@/assets/images/default_video.jpg"
                          class="TopicB1_Video BannerHover"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row justify-content-center"
                v-show="Booth_Design == 'B2'"
              >
                <div class="B2">
                  <!-- <div class="h3 mb-4 text-center">Preview of booth display</div> -->

                  <div class="mb-0">
                    <div class="ExhType">
                      <div v-show="hasCard">
                        <span
                          class="TopicB2_dotCard pointer"
                          @click="openInquiryModal"
                          ><i class="far fa-dot-circle"></i>
                          <div class="TopicB2_staffArea"></div>
                        </span>
                      </div>

                      <img
                        src="@/assets/images/Expo_Topic4.png"
                        width="900px"
                      />

                      <div class="B2_Logobanner row align-items-center">
                        <div class="col-4">
                          <div class="logImgFrame">
                            <img
                              :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                              alt=""
                              width="70%"
                            />
                          </div>
                        </div>
                        <div class="col-8">
                          <div class="font-weight-bold" style="font-size: 12px">
                            {{ OnlineExpoProfile.MemberComName }}
                          </div>
                        </div>
                      </div>

                      <a :href="ExpoL_Banner1" data-fancybox>
                        <img
                          :src="ExpoM_Banner1"
                          class="TopicB2_Banner01 BannerHover img-thumbnailB2"
                        />
                        <span class="TopicB2_dot1"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <a :href="ExpoL_Banner2" data-fancybox>
                        <img
                          :src="ExpoM_Banner2"
                          class="TopicB2_Banner02 BannerHover img-thumbnailB2"
                        />
                        <span class="TopicB2_dot2"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <a :href="ExpoL_Banner3" data-fancybox>
                        <img
                          :src="ExpoM_Banner3"
                          class="TopicB2_Banner03 BannerHover img-thumbnailB2"
                        />
                        <span class="TopicB2_dot3"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <a :href="ExpoL_Banner4" data-fancybox>
                        <img
                          :src="ExpoM_Banner4"
                          class="TopicB2_Banner04 BannerHover img-thumbnailB2"
                        />
                        <span class="TopicB2_dot4"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <span v-if="ExpovideoLink">
                        <a
                          :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                          frameborder="0"
                          allow="autoplay; encrypted-media"
                          data-fancybox
                          data-width="640"
                          data-height="360"
                        >
                          <img
                            :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                            class="TopicB2_Video BannerHover"
                          />
                          <span class="TopicB2_dotVideo"
                            ><i class="far fa-dot-circle"></i
                          ></span>
                        </a>
                      </span>

                      <span v-else-if="videoLink_Youku" class="TopicB2_Video">
                        <a
                          :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                          data-fancybox
                          data-type="iframe"
                          data-width="640"
                          data-height="360"
                          style="color: #434242"
                        >
                          <div class="topUK BannerHover">
                            <iframe
                              :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                              frameborder="0"
                              width="112px"
                              height="66px"
                            >
                            </iframe>

                            <div class="UKframe"></div>
                          </div>
                        </a>
                      </span>
                      <span v-else>
                        <img
                          src="@/assets/images/default_video.jpg"
                          class="TopicB2_Video BannerHover"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row justify-content-center"
                v-show="Booth_Design == 'B3'"
              >
                <div class="B3">
                  <div class="mb-0">
                    <div class="ExhType">
                      <div v-show="hasCard">
                        <span
                          class="TopicB3_dotCard pointer"
                          @click="openInquiryModal"
                          ><i class="far fa-dot-circle"></i>
                          <div class="TopicB3_staffArea"></div>
                        </span>
                      </div>

                      <img
                        src="@/assets/images/Expo_Topic5.png"
                        width="900px"
                      />

                      <div class="B3_Logobanner row align-items-center">
                        <div class="col-4">
                          <div class="logImgFrame">
                            <img
                              :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                              alt=""
                              width="70%"
                            />
                          </div>
                        </div>
                        <div class="col-8">
                          <div class="font-weight-bold" style="font-size: 12px">
                            {{ OnlineExpoProfile.MemberComName }}
                          </div>
                        </div>
                      </div>

                      <a :href="ExpoL_Banner1" data-fancybox>
                        <img
                          :src="ExpoM_Banner1"
                          class="TopicB3_Banner01 BannerHover img-thumbnailB3"
                        />
                        <span class="TopicB3_dot1"
                          ><i
                            class="far fa-dot-circle"
                            style="font-size: 13px"
                          ></i
                        ></span>
                      </a>
                      <a :href="ExpoL_Banner2" data-fancybox>
                        <img
                          :src="ExpoM_Banner2"
                          class="TopicB3_Banner02 BannerHover img-thumbnailB3"
                        />
                        <span class="TopicB3_dot2"
                          ><i
                            class="far fa-dot-circle"
                            style="font-size: 13px"
                          ></i
                        ></span>
                      </a>
                      <a :href="ExpoL_Banner3" data-fancybox>
                        <img
                          :src="ExpoM_Banner3"
                          class="TopicB3_Banner03 BannerHover img-thumbnailB3"
                        />
                        <span class="TopicB3_dot3"
                          ><i
                            class="far fa-dot-circle"
                            style="font-size: 13px"
                          ></i
                        ></span>
                      </a>
                      <a :href="ExpoL_Banner4" data-fancybox>
                        <img
                          :src="ExpoM_Banner4"
                          class="TopicB3_Banner04 BannerHover img-thumbnailB3"
                        />
                        <span class="TopicB3_dot4"
                          ><i
                            class="far fa-dot-circle"
                            style="font-size: 13px"
                          ></i
                        ></span>
                      </a>
                      <span v-if="ExpovideoLink">
                        <a
                          :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                          frameborder="0"
                          allow="autoplay; encrypted-media"
                          data-fancybox
                          data-width="640"
                          data-height="360"
                        >
                          <img
                            :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                            class="TopicB3_Video BannerHover"
                          />
                        </a>

                        <span class="TopicB3_dotVideo"
                          ><i
                            class="far fa-dot-circle"
                            style="font-size: 13px"
                          ></i
                        ></span>
                      </span>

                      <span v-else-if="videoLink_Youku" class="TopicB3_Video">
                        <a
                          :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                          data-fancybox
                          data-type="iframe"
                          data-width="640"
                          data-height="360"
                          style="color: #434242"
                        >
                          <div class="topUK BannerHover">
                            <iframe
                              :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                              frameborder="0"
                              width="104px"
                              height="60px"
                            >
                            </iframe>

                            <div class="UKframe"></div>
                          </div>
                        </a>

                        <span class="TopicB3_dotVideo"
                          ><i
                            class="far fa-dot-circle"
                            style="font-size: 13px"
                          ></i
                        ></span>
                      </span>
                      <span v-else>
                        <img
                          src="@/assets/images/default_video.jpg"
                          class="TopicB3_Video BannerHover"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row justify-content-center"
                v-show="Booth_Design == 'B4'"
              >
                <div class="B4">
                  <!-- <div class="h3 mb-4 text-center">Preview of booth display</div> -->
                  <div class="mb-0">
                    <div class="ExhType">
                      <div v-show="hasCard">
                        <span
                          class="TopicB4_dotCard pointer"
                          @click="openInquiryModal"
                          ><i class="far fa-dot-circle"></i>
                          <div class="TopicB4_staffArea"></div>
                        </span>
                      </div>
                      <img
                        src="@/assets/images/Expo_Topic6.png"
                        width="900px"
                      />

                      <div class="B4_Logobanner row align-items-center">
                        <div class="col-4">
                          <div class="logImgFrame">
                            <img
                              :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                              alt=""
                              width="70%"
                            />
                          </div>
                        </div>
                        <div class="col-8">
                          <div class="font-weight-bold" style="font-size: 12px">
                            {{ OnlineExpoProfile.MemberComName }}
                          </div>
                        </div>
                      </div>

                      <a :href="ExpoL_Banner1" data-fancybox>
                        <img
                          :src="ExpoM_Banner1"
                          class="TopicB4_Banner01 BannerHover img-thumbnailB4"
                        />
                        <span class="TopicB4_dot1"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <a :href="ExpoL_Banner2" data-fancybox>
                        <img
                          :src="ExpoM_Banner2"
                          class="TopicB4_Banner02 BannerHover img-thumbnailB4"
                        />
                        <span class="TopicB4_dot2"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <a :href="ExpoL_Banner3" data-fancybox>
                        <img
                          :src="ExpoM_Banner3"
                          class="TopicB4_Banner03 BannerHover img-thumbnailB4"
                        />
                        <span class="TopicB4_dot3"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <a :href="ExpoL_Banner4" data-fancybox>
                        <img
                          :src="ExpoM_Banner4"
                          class="TopicB4_Banner04 BannerHover img-thumbnailB4"
                        />
                        <span class="TopicB4_dot4"
                          ><i class="far fa-dot-circle"></i
                        ></span>
                      </a>
                      <span v-if="ExpovideoLink">
                        <a
                          :href="`https://www.youtube.com/embed/${ExpovideoLink}`"
                          frameborder="0"
                          allow="autoplay; encrypted-media"
                          data-fancybox
                          data-width="640"
                          data-height="360"
                        >
                          <img
                            :src="`https://img.youtube.com/vi/${ExpovideoLink}/mqdefault.jpg`"
                            class="TopicB4_Video BannerHover"
                          />
                          <span class="TopicB4_dotVideo"
                            ><i class="far fa-dot-circle"></i
                          ></span>
                        </a>
                      </span>

                      <span v-else-if="videoLink_Youku" class="TopicB4_Video">
                        <a
                          :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                          data-fancybox
                          data-type="iframe"
                          data-width="640"
                          data-height="360"
                          style="color: #434242"
                        >
                          <div class="topUK BannerHover">
                            <iframe
                              :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                              frameborder="0"
                              width="114px"
                              height="65px"
                            >
                            </iframe>

                            <div class="UKframe"></div>
                          </div>
                        </a>
                      </span>
                      <span v-else>
                        <img
                          src="@/assets/images/default_video.jpg"
                          class="TopicB4_Video BannerHover"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 項目ICON列表 -->
              <div
                class="d-flex iconLine justify-content-around align-items-center"
                style="color: white"
              >
                <div
                  class="text-center pointer iconOpenHover"
                  @click="openUserModal"
                >
                  <img
                    src="@/assets/images/onlineExpo_profile.png"
                    width="55px"
                    alt=""
                  />
                  <div class="mt-2" style="font-size: 17px">Profile</div>
                </div>
                <div
                  class="text-center pointer iconOpenHover"
                  @click="openProductModal"
                >
                  <img
                    src="@/assets/images/onlineExpo_products.png"
                    width="55px"
                    alt=""
                  />
                  <div class="mt-2" style="font-size: 17px">Products</div>
                </div>
                <div
                  class="text-center pointer iconOpenHover"
                  @click="openVideoModal"
                >
                  <img
                    src="@/assets/images/onlineExpo_video.png"
                    width="55px"
                    alt=""
                  />
                  <div class="mt-2" style="font-size: 17px">Videos</div>
                </div>
                <div
                  class="text-center pointer iconOpenHover"
                  @click="openNewsModal"
                >
                  <img
                    src="@/assets/images/onlineExpo_news.png"
                    width="55px"
                    alt=""
                  />
                  <div class="mt-2" style="font-size: 17px">Press Release</div>
                </div>
                <div
                  class="text-center pointer iconOpenHover"
                  @click="openInquiryModal"
                >
                  <img
                    src="@/assets/images/onlineExpo_chat.png"
                    width="55px"
                    alt=""
                  />
                  <div class="mt-2" style="font-size: 17px">Inquiry</div>
                </div>
              </div>
            </div>

            <div class="text-center mt-4">
              <div class="d-flex align-items-center justify-content-center">
                <img
                  src="@/assets/images/bell.png"
                  alt=""
                  width="28px"
                  class="mr-2"
                />
                <div>
                  While completing all the information required, please make
                  sure your
                  <a :href="`profile?no=${RegNo}`">Basic Information</a>、
                  <a :href="`product?no=${RegNo}`">Products</a>、
                  <a :href="`news?no=${RegNo}`">Press Release</a>、
                  <a :href="`video?no=${RegNo}`">Video</a> pages are uploaded as
                  well.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Bootstrap 彈跳視窗區 -->

      <div
        class="modal fade"
        id="venderCard"
        tabindex="-1"
        role="dialog"
        aria-labelledby="venderCardTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col-sm-10 mb-2" v-for="item in CardInfo">
                <div v-if="item.Verified == 1">
                  <div class="card mt-3 bg-white profileCard shadow">
                    <div class="card-header1">
                      <p class="my-3">&nbsp;</p>
                    </div>

                    <div class="card-body">
                      <div class="row m-3">
                        <div class="col-md-3 mr-4">
                          <div class="mt-1">
                            <img
                              :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${item.Logo}`"
                              width="100px"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="col-md-8 ml-2">
                          <h3 class="mb-3">{{ item.Company }}</h3>
                          <p>{{ item.Dept }}</p>
                          <h3 class="mb-3 font-weight-bold">
                            {{ item.Name }}
                          </h3>
                          <p v-if="item.Address">
                            <i
                              class="fas fa-map-marker-alt mr-1 mb-1"
                              style="color: #6b6766"
                            ></i>
                            {{ item.Address }}
                          </p>
                          <div v-if="item.Tel">
                            <i
                              class="fas fa-phone-square-alt mr-1 mb-1"
                              style="color: #6b6766"
                            ></i>
                            {{ item.Tel }} #{{ item.Ext }}
                          </div>
                          <div v-if="item.Email">
                            <i
                              class="fas fa-envelope-square mr-1"
                              style="color: #6b6766"
                            ></i>
                            {{ item.Email }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 參展商基本資訊 -->

      <div
        class="modal fade"
        id="UserDesk"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLongTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="title_fontStyle">Basic Information</h1>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div
                class="row justify-content-center align-items-center px-5 py-3"
              >
                <div class="col-lg-3 text-center">
                  <div class="logImgFrame_ExhInfo">
                    <img
                      :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${OnlineExpoProfile.MemberComLogo}`"
                      width="80%"
                      alt=""
                      class="mb-2"
                    />
                  </div>
                </div>
                <div class="col-lg-9">
                  <h4 style="font-weight: bold">
                    {{ OnlineExpoProfile.MemberComName }}
                  </h4>
                  <p>
                    Country: <span>{{ OnlineExpoProfile.Country }}</span>
                  </p>
                  <p>
                    Category: <span>{{ OnlineExpoProfile.ExhibArea }}</span>
                  </p>
                  <p>Booth No: {{ OnlineExpoProfile.BoothNo }}</p>
                </div>
              </div>

              <div class="px-5 py-3">
                <h3 class="my-3 title_fontStyle">Exhibitor Profile</h3>

                <p style="white-space: pre-wrap">{{ r_Profile }}</p>

                <p>&zwnj;</p>

                <div>
                  <h3 class="title_fontStyle mb-2">Brand</h3>
                  <p>
                    {{ OnlineExpoProfile.BrandName }}
                  </p>
                </div>

                <p>&zwnj;</p>

                <div class="my-4">
                  <h5 class="title_fontStyle mb-2">Website</h5>
                  <a :href="ExhInfo.Url" target="_blank">{{
                    OnlineExpoProfile.Url
                  }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 卡片基本資訊 -->
      <div
        class="modal fade"
        id="openInquiryModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLongTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="title_fontStyle">Inquiry</h1>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body p-4 m-2">
              <h3 class="ml-1">{{ OnlineExpoProfile.MemberComName }}</h3>
              <!-- <h5 class="my-4">Select a representative to start live chat</h5> -->

              <div class="d-flex mt-4">
                <div class="col-lg-6 mb-4">
                  <p class="font-weight-bold" style="font-size: 18px">Name</p>
                  <p>User Name</p>
                </div>
                <div class="col-lg-6 mb-4">
                  <p class="font-weight-bold" style="font-size: 18px">Email</p>
                  <p>UserEmail@xxxx.com.tw</p>
                </div>
              </div>

              <div class="d-flex">
                <div class="col-lg-6">
                  <div class="form-group mb-4">
                    <label
                      for="inputTel"
                      class="form_title font-weight-bold"
                      style="font-size: 18px"
                      >Tel</label
                    >
                    <input
                      class="form-control"
                      type="text"
                      id="inputTel"
                      maxlength="30"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group mb-4">
                    <label
                      for="inputTel"
                      class="form_title font-weight-bold"
                      style="font-size: 18px"
                      >Mobile</label
                    >
                    <input
                      class="form-control"
                      type="text"
                      id="inputTel"
                      maxlength="30"
                    />
                  </div>
                </div>
              </div>

              <div class="mb-3 ml-1">
                <label
                  for="validationTextarea"
                  style="font-size: 18px"
                  class="font-weight-bold"
                  >Content <span style="color: red">*</span></label
                >
                <textarea
                  class="form-control"
                  rows="6"
                  id="validationTextarea"
                  placeholder=""
                  name="Content"
                ></textarea>
              </div>
              <div class="text-center">
                <button
                  type="button"
                  class="btn btn-lg btn-secondary px-4"
                  style="font-size: 16px"
                  disabled=""
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div
        class="modal fade"
        id="openInquiryModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLongTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="title_fontStyle">Inquiry</h1>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body p-4 m-2">
              <h1>Live Chat</h1>
              <h5 class="my-4">Select a representative to start live chat</h5>

              <div class="row">
                <div class="col-lg-6 mt-1 mb-3" v-for="item in CardInfo">
                  <div class="card bg-white profileCard shadow">
                    <div class="card-header">
                      <p class="my-3">&nbsp;</p>
                    </div>

                    <div class="card-body">
                      <div class="row justify-content-between m-2">
                        <div class="col-lg-3">
                          <div class="mt-3">
                            <img
                              :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${item.Logo}`"
                              width="120px"
                              alt=""
                            />
                          </div>
                        </div>

                        <div class="col-lg-8">
                          <h5 class="mb-3">{{ item.Company }}</h5>
                          <p>{{ item.Dept }}</p>

                          <h5 class="mb-3 font-weight-bold">{{ item.Name }}</h5>

                          <div v-if="item.Address">
                            <i class="fas fa-map-marker-alt mr-1 mb-1" style="color: #6b6766"></i> {{ item.Address }}
                          </div>
                          <div v-if="item.Tel">
                            <i class="fas fa-phone-square-alt mr-1 mb-1" style="color: #6b6766"></i> {{ item.Tel }} #{{
                              item.Ext
                            }}
                          </div>
                          <div v-if="item.Email">
                            <i class="fas fa-envelope-square mr-1" style="color: #6b6766"></i>
                            {{ item.Email }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <h5 class="mt-4">Or leave an inquiry here:</h5>
              <div class="btn btn-primary px-3 py-2 mt-4 disabled" style="border-radius: 30px">
                <span style="font-size: 16px; border-radius: 30px"> Inquire </span>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- 新聞稿資訊 -->

      <div
        class="modal fade"
        id="openNewsModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLongTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="title_fontStyle">Press Release</h1>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body my-3 px-4">
              <div v-if="hasNews">
                <div
                  class="my-4"
                  v-for="(item, index) in ExhNewsList"
                  :key="index"
                >
                  <div class="d-flex">
                    <h3 class="mr-2">{{ index + 1 }}.</h3>
                    <div>
                      <div class="title_fontStyle h4 font-weight-normal">
                        {{ item.NewsTopic }}
                      </div>
                      <div>
                        {{ item.UpdateTime }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else>
                <h4 style="margin-top: 30px">No Data</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 影片資訊 -->

      <div
        class="modal"
        id="openVideoModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLongTitle"
        aria-hidden="true"
        style="z-index: 3000"
      >
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="title_fontStyle">Videos</h1>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>&zwnj;</p>

              <div v-if="!hasVideo" class="mx-4">
                <h4 style="margin-top: 30px">No Data</h4>
              </div>
              <div v-else>
                <div class="row mx-4">
                  <div class="col-lg-4 mb-4" v-for="item in exhVideo">
                    <span v-if="item.videoLink">
                      <a
                        :href="`https://www.youtube.com/embed/${item.videoLink}`"
                        frameborder="0"
                        allow="autoplay; encrypted-media"
                        data-fancybox
                        data-width="1280"
                        data-height="720"
                      >
                        <img
                          :src="`https://img.youtube.com/vi/${item.videoLink}/mqdefault.jpg`"
                          width="100%"
                          alt=""
                        />
                      </a>
                    </span>

                    <span v-else-if="item.videoLink_Youku">
                      <a
                        :href="`https://player.youku.com/embed/${videoLink_Youku}==?rel=0&amp;autoplay=1`"
                        data-fancybox
                        data-type="iframe"
                        data-width="1280"
                        data-height="720"
                        style="color: #434242"
                      >
                        <div class="topUK">
                          <div class="embed-responsive embed-responsive-4by3">
                            <iframe
                              class="embed-responsive-item"
                              :src="`https://player.youku.com/embed/${videoLink_Youku}`"
                              frameborder="0"
                              width="100%"
                            >
                            </iframe>
                          </div>
                          <div class="UKframe"></div>
                        </div>
                      </a>
                    </span>

                    <div class="my-2">
                      <div
                        style="height: 50px; font-size: 20px; font-weight: bold"
                      >
                        {{ item.VideoTopic }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 產品資訊 -->

      <div
        class="modal fade"
        id="openProductModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLongTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="title_fontStyle">Products</h1>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body my-2">
              <div v-if="hasProduct">
                <div class="row m-4">
                  <div class="col-lg-4 my-3" v-for="item in GetExhPro">
                    <div class="text-center bg-white p-2 border card-effect">
                      <div class="logImgFrame_product">
                        <img
                          :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${item.ProImg}`"
                          width="60%"
                          alt=""
                        />
                      </div>
                      <div class="ProNameFrame">
                        <div
                          style="
                            height: 50px;
                            font-size: 16px;
                            font-weight: bold;
                          "
                        >
                          <div class="ellipsis_pro">
                            {{ item.ProName }}
                          </div>
                        </div>
                        <div class="mb-2" style="height: 30px">
                          <div
                            class="text-muted ellipsis_exh"
                            style="font-size: 12px"
                          >
                            {{ item.ComName }}
                          </div>
                        </div>
                      </div>

                      <span>
                        <img
                          class="iconOpenHover"
                          src="@/assets/images/OnlineExpo_like.png"
                          width="20px"
                          alt=""
                        />
                        <span style="font-size: 14px">
                          {{ item.FavCount }}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else>
                <h4 style="margin-top: 30px" class="m-4">No Data</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

import defaultImg from "@/assets/images/default_230x450.jpg";

export default {
  metaInfo() {
    return {
      title: `Online Expo Settings - Chan Chao Exhibitor's Online Service System`,
    };
  },

  data() {
    return {
      UserId: "",
      CSRF_Token: "",
      RegNo: "",
      lang: "en",

      previews: {},
      previewStyle1: {},
      modelSrc: "./images/BannerA.jpg",
      modelSrc4: "./images/BannerC.jpg",
      modelSrc_0: "./images/default_sm.jpg",
      modelSrc_1: "./images/BannerB.jpg",
      modelSrc_2: "./images/default_sm.jpg",
      modelSrc_4: "./images/Exh_type2.jpg",
      NomodelSrc: "./images/default_sm.jpg",
      showImg: false,

      option: {
        img: "",
        max: 9999,
        enlarge: 1,
        mode: "contain",
        centerBox: false,
        canMove: true,
        infoTrue: true,
        fixedBox: true,
        canMoveBox: false,
        autoCrop: true,
        autoCropWidth: 500,
        autoCropHeight: 500,
        full: true,
        high: true,
        original: true,
        size: 1,
        outputType: "webp",
      },

      fixed: true,
      fixedNumber1: [1, 2],
      fixedNumber4: [2, 1],

      logoImg: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",

      // 攤位內容
      Booth_Design: "",
      Serno: "",
      ExpovideoLink: "",
      videoLink_Youku: "",
      ExpoM_Banner1: "",
      ExpoM_Banner2: "",
      ExpoM_Banner3: "",
      ExpoM_Banner4: "",
      ExpoL_Banner1: "",
      ExpoL_Banner2: "",
      ExpoL_Banner3: "",
      ExpoL_Banner4: "",

      isVip: false,
      hasExpoVideo: false,
      hasExpoTopic: false,
      hasAllBanner: false,
      hasCard: false,
      firstEntry: true,

      CardInfo: [],
      ExhibitorWebsite: "",
      showOnlineExhLink: false,

      ExhInfo: {},
      r_Profile: "", //去<br>
      OnlineExhcode: "", //加密展code

      hasProduct: true,
      GetExhPro: {},

      exhVideo: [],
      hasVideo: true,

      hasNews: true,
      ExhNewsList: [],

      VerifiedCardInfo: [],
      CardInfo: [],

      Useremail: "",
      Username: "",
      CompanyTel: "",
      allPhone: "",

      //判斷各頁狀態儀表版值
      OnlineExpolayoutStatus: "",
      PressReleaseStatus: "",
      VideoStatus: "",
      ProductStatus: "",
      BasicinformationStatus: "",

      //判斷儀表板是否有線上展
      HasOnlineExpo: "",
      openOnlineExpo: "",
      showOnlineStatus: false,

      OnlineExpoProfile: {},
      ExhLogo: "",
    };
  },
  methods: {
    openUserModal() {
      $("#UserDesk").modal("show");
    },

    openProductModal() {
      const vm = this;

      axios
        .get(
          `https://www.chanchao.com.tw/apiExhibitors/BoothPreviewProduct/${vm.RegNo}`,
        )
        .then((response) => {
          // console.log(response.data.Data)

          if (response.data.Code == 200) {
            vm.hasProduct = true;
            vm.GetExhPro = response.data.Data;
            $("#openProductModal").modal("show");
          } else if (response.data.Code == 404) {
            vm.hasProduct = false;
            $("#openProductModal").modal("show");
          }
        });
    },

    openVideoModal() {
      const vm = this;

      axios
        .get(
          `https://www.chanchao.com.tw/apiExhibitors/BoothPreviewVideo/${vm.RegNo}`,
        )
        .then((response) => {
          // console.log(response.data.Data)

          if (response.data.Code == 200) {
            vm.hasVideo = true;
            vm.exhVideo = response.data.Data;

            $("#openVideoModal").modal("show");
          } else if (response.data.Code == 404) {
            vm.hasVideo = false;
            $("#openVideoModal").modal("show");
          }
        });
    },
    openNewsModal() {
      const vm = this;

      //取得參展商新聞稿資料

      axios
        .get(
          `https://www.chanchao.com.tw/apiExhibitors/BoothPreviewPressRelease/${vm.RegNo}`,
        )
        .then((response) => {
          if (response.data.Code == 200) {
            vm.hasNews = true;
            vm.ExhNewsList = response.data.Data;
            $("#openNewsModal").modal("show");
          } else if (response.data.Code == 404) {
            vm.hasNews = false;
            $("#openNewsModal").modal("show");
          }
        });
    },

    openInquiryModal() {
      //取得攤位人員資料

      //取得攤販資料則取消瀏覽畫面

      console.log(1);

      $("#openInquiryModal").modal("show");
    },

    closefancybox() {
      parent.$.fancybox.close();
    },

    saveBoothDesign() {
      const vm = this;
      const url = "/apiExhibitors/EditOnlineExpoBoothType/";

      const info = {
        RegNo: vm.RegNo,
        Booth_Design: vm.Booth_Design,
        CSRF: vm.CSRF_Token,
      };

      axios.post(url, info).then(function (response) {
        if (response.data.Code == 200) {
          // alert('您已成功設定攤位版型！')
          vm.closefancybox();
          parent.window.location.reload();
        } else if (response.data.Code == 251 || response.data.Code == 500) {
          alert("System is busy, please try again later.");
          vm.closefancybox();
          parent.window.location.reload();
        } else if (response.data.Code == 252) {
          vm.closefancybox();
          document.location.href = `https://www.chanchao.com.tw/`;
        }
      });
    },

    EsaveBoothDesign() {
      const vm = this;
      const url = "/apiExhibitors/EditOnlineExpoBoothType/";

      const info = {
        RegNo: vm.RegNo,
        Booth_Design: vm.Booth_Design,
        CSRF: vm.CSRF_Token,
      };

      axios.post(url, info).then(function (response) {
        if (response.data.Code == 200) {
          // alert('您已成功設定攤位版型！')
          vm.closefancybox();
          parent.window.location.reload();
        } else if (response.data.Code == 251 || response.data.Code == 500) {
          alert("系統忙碌，請稍後再試");
          vm.closefancybox();
          parent.window.location.reload();
        } else if (response.data.Code == 252) {
          vm.closefancybox();
          document.location.href = `https://www.chanchao.com.tw/`;
        }
      });
    },

    openCardModal() {
      $("#venderCard").modal("show");
    },
  },

  created() {
    const vm = this;

    //取得語系

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });
    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    //取得參展商總資訊
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`,
      )
      .then((response) => {
        vm.logoImg = response.data.Data.ExhLogo;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;
        vm.OnlineExhBegin = response.data.Data.OnlineExpoBegin;
        vm.OnlineExhEnd = response.data.Data.OnlineExpoEnd;
        vm.OnlineExhcode = response.data.Data.exhcode;

        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;

        let today = new Date();
        today.setDate(today.getDate());

        let OpenShowExhDate = new Date(response.data.Data.OnlineExpoBegin);
        // console.log(response.data.Data.OnlineExpoBegin)
        // console.log(OpenShowExhDate)

        OpenShowExhDate.setDate(OpenShowExhDate.getDate() - 14);

        // console.log(OpenShowExhDate)

        let CloseDay = new Date(response.data.Data.OnlineExpoEnd);
        CloseDay.setDate(CloseDay.getDate() + 1);

        // console.log(CloseDay)

        if (today > OpenShowExhDate && today < CloseDay) {
          vm.showOnlineExhLink = true;
        } else {
          vm.showOnlineExhLink = false;
        }
      });

    //取得Logo圖片 & 取得VIP等級
    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        // console.log(response.data.Data)

        //取得是否填寫狀態盤的值

        vm.OnlineExpolayoutStatus = response.data.Data.OnlineExpolayoutStatus;
        vm.PressReleaseStatus = response.data.Data.PressReleaseStatus;
        vm.VideoStatus = response.data.Data.VideoStatus;
        vm.ProductStatus = response.data.Data.ProductStatus;
        vm.BasicinformationStatus = response.data.Data.BasicinformationStatus;

        if (response.data.Data.Vip == 3) {
          vm.isVip = true;
        } else {
          vm.isVip = false;
        }

        vm.HasOnlineExpo = response.data.Data.Virtual;

        //取得是否開啟線上展權限
        axios
          .get(
            `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`,
          )
          .then((response) => {
            // console.log(response.data.Data)

            vm.openOnlineExpo = response.data.Data.OnlineExpo_Archived;

            if (vm.openOnlineExpo == 1 && vm.HasOnlineExpo == 1) {
              vm.showOnlineStatus = true;
            } else {
              vm.showOnlineStatus = false;
              window.location.href = `home?no=${vm.RegNo}`;
            }
          });

        //取得線上展總資料
        axios
          .get(
            `https://www.chanchao.com.tw/apiExhibitors/DisplayOnlineExpoControl/${vm.RegNo}`,
          )
          .then((response) => {
            // console.log(response.data.Data)

            vm.OnlineExpoProfile = response.data.Data;

            if (response.data.Data.Profile) {
              vm.r_Profile = response.data.Data.Profile.replace(/<br>/g, "\n");
            }

            if (vm.showOnlineExhLink) {
              vm.ExhibitorWebsite = response.data.Data.ExhibitorWebsite;
            }

            if (response.data.Data.Booth_Design) {
              vm.hasExpoTopic = true;

              vm.Booth_Design = response.data.Data.Booth_Design;
            } else {
              vm.hasExpoTopic = false;
              $(".isTopic").addClass("HideTopic");
            }

            vm.Serno = response.data.Data.Serno;
            if (
              response.data.Data.video_Link ||
              response.data.Data.videoLink_Youku
            ) {
              vm.ExpovideoLink = response.data.Data.video_Link;
              vm.videoLink_Youku = response.data.Data.videoLink_Youku;
              vm.hasExpoVideo = true;
            } else {
              vm.hasExpoVideo = false;
            }

            //須補足是VIP兩個版型的判斷式

            if (vm.isVip) {
              if (
                response.data.Data.Banner1M ||
                response.data.Data.Banner2M ||
                response.data.Data.Banner3M ||
                response.data.Data.Banner4M
              ) {
                vm.hasAllBanner = true;
              } else {
                vm.hasAllBanner = false;
              }
            } else {
              if (response.data.Data.Banner1M || response.data.Data.Banner2M) {
                vm.hasAllBanner = true;
              } else {
                vm.hasAllBanner = false;
              }
            }

            if (response.data.Data.Banner1L) {
              vm.ExpoM_Banner1 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/M/${response.data.Data.Banner1M}`;
              vm.ExpoL_Banner1 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner1L}`;
            } else {
              if (vm.lang == "tw") {
                vm.ExpoM_Banner1 = defaultImg;
                vm.ExpoL_Banner1 = defaultImg;
              } else {
                vm.ExpoM_Banner1 = defaultImg;
                vm.ExpoL_Banner1 = defaultImg;
              }
            }

            if (response.data.Data.Banner2L) {
              vm.ExpoM_Banner2 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/M/${response.data.Data.Banner2M}`;
              vm.ExpoL_Banner2 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner2L}`;
            } else {
              if (vm.lang == "tw") {
                vm.ExpoM_Banner2 = defaultImg;
                vm.ExpoL_Banner2 = defaultImg;
              } else {
                vm.ExpoM_Banner2 = defaultImg;
                vm.ExpoL_Banner2 = defaultImg;
              }
            }

            if (response.data.Data.Banner3L) {
              vm.ExpoM_Banner3 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/M/${response.data.Data.Banner3M}`;
              vm.ExpoL_Banner3 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner3L}`;
            } else {
              if (vm.lang == "tw") {
                vm.ExpoM_Banner3 = defaultImg;
                vm.ExpoL_Banner3 = defaultImg;
              } else {
                vm.ExpoM_Banner3 = defaultImg;
                vm.ExpoL_Banner3 = defaultImg;
              }
            }

            if (response.data.Data.Banner4L) {
              vm.ExpoM_Banner4 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/M/${response.data.Data.Banner4M}`;
              vm.ExpoL_Banner4 = `//www.chanchao.com.tw/exhibitorservicefiles/VirtualBooth/L/${response.data.Data.Banner4L}`;
            } else {
              if (vm.lang == "tw") {
                vm.ExpoM_Banner4 = defaultImg;
                vm.ExpoL_Banner4 = defaultImg;
              } else {
                vm.ExpoM_Banner4 = defaultImg;
                vm.ExpoL_Banner4 = defaultImg;
              }
            }

            //判定是否為首次進入，及增加灰底效果

            if (
              !vm.hasExpoVideo &&
              !vm.hasExpoTopic &&
              !vm.hasAllBanner &&
              !vm.hasCard
            ) {
              vm.firstEntry = true;
              $(".linkdisable")
                .attr("disabled", true)
                .css("pointer-events", "none");

              $(".AddGrayFrame").addClass("graystyle");
            } else {
              vm.firstEntry = false;
              $(".linkdisable")
                .attr("disabled", false)
                .css("pointer-events", "auto");

              $(".AddGrayFrame").removeClass("graystyle");
            }
          });
      });

    //取得線上展說明文字

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/BoothPreviewProduct/${vm.RegNo}`,
      )
      .then((response) => {
        // console.log(response.data.Data)
      });

    //判定存在卡片與否

    axios
      .get(
        `https://www.chanchao.com.tw/apiOnlineExpo/v2/Boothstaff/${vm.RegNo}`,
      )
      .then((response) => {
        // console.log(response.data.Data)

        vm.CardInfo = response.data;

        let findCard = vm.CardInfo.filter((item) => {
          return item.Verified == 1;
        });

        // console.log(findCard)

        if (findCard.length > 0) {
          vm.hasCard = true;
        } else {
          vm.hasCard = false;
        }
      });
  },
};
</script>

<style lang="scss">
.hideBtn {
  display: none;
}

.MbIconSize {
  font-size: 10px;
}

.card-header1 {
  margin-bottom: 0;
  background-color: #eecf8d;
  border-bottom: 0px;
}

#style-3::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #ffc0cb;
}

#style-3::-webkit-scrollbar {
  width: 6px;
  background-color: black;
}

#style-3::-webkit-scrollbar-thumb {
  background-color: #bb6573;
}

.modal-body {
  padding: 0rem;
}

.graystyle {
  filter: brightness(0.6);
}

.uncomplete {
  background-image: url("../../../assets/images/tickGray.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.complete {
  background-image: url("../../../assets/images/tick.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.uncomplete2 {
  background-image: url("../../../assets/images/warning_1.png");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.complete2 {
  background-image: url("../../../assets/images/check_1.png");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.card {
  -webkit-box-shadow: -1px 1px 24px -7px rgba(92, 89, 92, 0.09);
  -moz-box-shadow: -1px 1px 24px -7px rgba(92, 89, 92, 0.09);
  box-shadow: -1px 1px 24px -7px rgba(92, 89, 92, 0.09);
}

.btn {
  padding: 0.285rem 0.35rem;
  font-size: 0.9rem;
}

.vendor_topic1 {
  background-image: url("../../../assets/images/Expo_Topic1.png");
}

.vendor_topic2 {
  background-image: url("../../../assets/images/Expo_Topic2.png");
}

.vendor_topic3 {
  background-image: url("../../../assets/images/Expo_Topic3.png");
}

.vendor_topic4 {
  background-image: url("../../../assets/images/Expo_Topic4.png");
}

.vendor_topic5 {
  background-image: url("../../../assets/images/Expo_Topic5.png");
}

.vendor_topic6 {
  background-image: url("../../../assets/images/Expo_Topic6.png");
}

.ExhType {
  max-width: 1000px;
  max-height: 1000px;
  /* overflow-x: scroll; */
  background-repeat: no-repeat;
  position: relative;
}

.MbExhType {
  position: relative;
}

/* Banner Hover效果 */

.BannerHover:hover {
  box-shadow: 1px 1px 10px 1px rgb(189 189 180);
  opacity: 0.6;
  cursor: pointer;
  position: absolute;
}

/* A1攤位區 */

.img-thumbnailA1 {
  border: 1px solid #63686a;
  border-radius: 0.15rem;
  max-width: 100%;
  height: auto;
}

.img-thumbnailA1M {
  border: 1px solid #63686a;
  border-radius: 0.15rem;
  max-width: 100%;
  height: auto;
}

.TopicA1_dotCard {
  position: absolute;
  left: 182px;
  top: 192px;
  animation: flicker 1s linear infinite;
  color: #ffee50;
}

.TopicA1_staffArea {
  position: absolute;
  left: -65px;
  top: 22px;
  width: 155px;
  height: 102px;
}

.TopicA1_dot1 {
  position: absolute;
  left: 514px;
  top: 135px;
  animation: flicker 1s linear infinite;
  color: #ffee50;
}

.TopicA1_Banner01 {
  position: absolute;
  left: 478px;
  top: 158px;
  width: 85px;
  height: 152px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

@keyframes flicker {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 1.2;
  }
}

.mTopicA1_Banner01 {
  position: absolute;
  left: 170px;
  top: 56px;
  width: 30px;
  height: 55px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicA1_dot2 {
  position: absolute;
  left: 625px;
  top: 135px;
  animation: flicker 1s linear infinite;
  color: #ffee50;
}

.TopicA1_Banner02 {
  position: absolute;
  left: 590px;
  top: 159px;
  width: 85px;
  height: 151px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicA1_Banner02 {
  position: absolute;
  left: 210px;
  top: 56px;
  width: 30px;
  height: 55px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicA1_dotVideo {
  position: absolute;
  left: 350px;
  top: 122px;
  animation: flicker 1s linear infinite;
  color: #ffee50;
}

.TopicA1_Video {
  position: absolute;
  left: 302px;
  top: 150px;
  width: 111px;
  height: 67px;
}

.mTopicA1_Video {
  position: absolute;
  left: 107px;
  top: 53px;
  width: 40px;
  height: 24px;
}

.TopicMbA1_dot1 {
  position: absolute;
  left: 180px;
  top: 38px;
  animation: flicker 1s linear infinite;
  color: #ffee50;
}

.TopicMbA1_dot2 {
  position: absolute;
  left: 219px;
  top: 38px;
  animation: flicker 1s linear infinite;
  color: #ffee50;
}

.TopicMbA1_Video {
  position: absolute;
  left: 122px;
  top: 34px;
  animation: flicker 1s linear infinite;
  color: #ffee50;
}

.TopicMbA1_dotCard {
  position: absolute;
  left: 61px;
  top: 62px;
  animation: flicker 1s linear infinite;
  color: #ffee50;
}

/* A2攤位區 */

.TopicA2_Banner01 {
  position: absolute;
  left: 156px;
  top: 235px;
  width: 87px;
  height: 152px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicA2_Banner01 {
  position: absolute;
  left: 56px;
  top: 84px;
  width: 31px;
  height: 54px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicA2_Banner02 {
  position: absolute;
  left: 263px;
  top: 236px;
  width: 86px;
  height: 150px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicA2_Banner02 {
  position: absolute;
  left: 93px;
  top: 84px;
  width: 31px;
  height: 54px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicA2_Video {
  position: absolute;
  left: 656px;
  top: 265px;
  width: 107px;
  height: 63px;
}

.mTopicA2_Video {
  position: absolute;
  left: 233px;
  top: 94px;
  width: 38px;
  height: 22px;
  color: #434242;
}

.TopicA2_dot1 {
  position: absolute;
  left: 195px;
  top: 208px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA2_dot2 {
  position: absolute;
  left: 300px;
  top: 208px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA2_dotVideo {
  position: absolute;
  left: 702px;
  top: 238px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA2_dotCard {
  position: absolute;
  left: 585px;
  top: 238px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA2_staffArea {
  position: absolute;
  left: -35px;
  top: 21px;
  width: 95px;
  height: 90px;
}

.TopicMbA2_dot1 {
  position: absolute;
  left: 66px;
  top: 65px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbA2_dot2 {
  position: absolute;
  left: 103px;
  top: 65px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbA2_Video {
  position: absolute;
  left: 245px;
  top: 74px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbA2_dotCard {
  position: absolute;
  left: 205px;
  top: 75px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

/* A3-A6的banner外框 */

.img-thumbnailA3 {
  border: 1px solid #b3b7b8;
  border-radius: 0.15rem;
  max-width: 100%;
  height: auto;
}

.img-thumbnailA4 {
  border: 1px solid #d3cdb5;
  border-radius: 0.15rem;
  max-width: 100%;
  height: auto;
}

.img-thumbnailA5 {
  border: 1px solid #b3b7b8;
  border-radius: 0.15rem;
  max-width: 100%;
  height: auto;
}

.img-thumbnailA6 {
  border: 1px solid #dddacf;
  border-radius: 0.15rem;
  max-width: 100%;
  height: auto;
}

.img-thumbnailA3M {
  border: 1px solid #b3b7b8;
  border-radius: 0.15rem;
  max-width: 100%;
  height: auto;
}

.img-thumbnailA4M {
  border: 1px solid #d3cdb5;
  border-radius: 0.15rem;
  max-width: 100%;
  height: auto;
}

.img-thumbnailA5M {
  border: 1px solid #b3b7b8;
  border-radius: 0.15rem;
  max-width: 100%;
  height: auto;
}

.img-thumbnailA6M {
  border: 1px solid #dddacf;
  border-radius: 0.15rem;
  max-width: 100%;
  height: auto;
}

/* A3攤位區 */

.TopicA3_Banner01 {
  position: absolute;
  left: 508px;
  top: 157px;
  width: 80px;
  height: 160px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicA3_Banner01 {
  position: absolute;
  left: 180px;
  top: 55px;
  width: 29px;
  height: 57px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicA3_Banner02 {
  position: absolute;
  left: 614px;
  top: 157px;
  width: 80px;
  height: 160px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicA3_Banner02 {
  position: absolute;
  left: 218px;
  top: 55px;
  width: 29px;
  height: 57px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicA3_Video {
  position: absolute;
  left: 247px;
  top: 157px;
  width: 111px;
  height: 68px;
}

.mTopicA3_Video {
  position: absolute;
  left: 88px;
  top: 55px;
  width: 39px;
  height: 25px;
}

.TopicA3_dot1 {
  position: absolute;
  left: 542px;
  top: 132px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA3_dot2 {
  position: absolute;
  left: 647px;
  top: 132px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA3_dotVideo {
  position: absolute;
  left: 295px;
  top: 129px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA3_dotCard {
  position: absolute;
  left: 126px;
  top: 323px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA3_staffArea {
  position: absolute;
  left: -55px;
  top: -121px;
  width: 125px;
  height: 260px;
}

.TopicMbA3_dot1 {
  position: absolute;
  left: 189px;
  top: 35px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbA3_dot2 {
  position: absolute;
  left: 226px;
  top: 35px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbA3_Video {
  position: absolute;
  left: 102px;
  top: 34px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbA3_dotCard {
  position: absolute;
  left: 41px;
  top: 110px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

/* A4攤位區 */

.TopicA4_Banner01 {
  position: absolute;
  left: 227px;
  top: 174px;
  width: 80px;
  height: 159px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicA4_Banner01 {
  position: absolute;
  left: 80px;
  top: 62px;
  width: 29px;
  height: 56px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicA4_Banner02 {
  position: absolute;
  left: 592px;
  top: 174px;
  width: 80px;
  height: 159px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicA4_Banner02 {
  position: absolute;
  left: 210px;
  top: 62px;
  width: 29px;
  height: 56px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicA4_Video {
  position: absolute;
  left: 396px;
  top: 207px;
  width: 116px;
  height: 77px;
}

.mTopicA4_Video {
  position: absolute;
  left: 141px;
  top: 73px;
  width: 41px;
  height: 28px;
}

.TopicA4_dot1 {
  position: absolute;
  left: 261px;
  top: 152px;

  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA4_dot2 {
  position: absolute;
  left: 625px;
  top: 152px;

  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA4_dotVideo {
  position: absolute;
  left: 447px;
  top: 179px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA4_dotCard {
  position: absolute;
  left: 708px;
  top: 223px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA4_staffArea {
  position: absolute;
  left: -31px;
  top: -11px;
  width: 75px;
  height: 172px;
}

.TopicMbA4_dot1 {
  position: absolute;
  left: 89px;
  top: 43px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbA4_dot2 {
  position: absolute;
  left: 219px;
  top: 43px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbA4_Video {
  position: absolute;
  left: 156px;
  top: 52px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbA4_dotCard {
  position: absolute;
  left: 248px;
  top: 69px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

/* A5攤位區 */

.TopicA5_Banner01 {
  position: absolute;
  left: 149px;
  top: 185px;
  width: 80px;
  height: 160px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicA5_Banner01 {
  position: absolute;
  left: 53px;
  top: 66px;
  width: 28px;
  height: 56px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicA5_Banner02 {
  position: absolute;
  left: 240px;
  top: 185px;
  width: 81px;
  height: 160px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicA5_Banner02 {
  position: absolute;
  left: 86px;
  top: 66px;
  width: 28px;
  height: 56px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicA5_Video {
  position: absolute;
  left: 647px;
  top: 215px;
  width: 115px;
  height: 77px;
}

.mTopicA5_Video {
  position: absolute;
  left: 230px;
  top: 77px;
  width: 41px;
  height: 27px;
}

.TopicA5_dot1 {
  position: absolute;
  left: 181px;
  top: 161px;

  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA5_dot2 {
  position: absolute;
  left: 274px;
  top: 161px;

  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA5_dotVideo {
  position: absolute;
  left: 697px;
  top: 188px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA5_dotCard {
  position: absolute;
  left: 582px;
  top: 223px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA5_staffArea {
  position: absolute;
  left: -31px;
  top: -11px;
  width: 85px;
  height: 202px;
}

.TopicMbA5_dot1 {
  position: absolute;
  left: 62px;
  top: 47px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbA5_dot2 {
  position: absolute;
  left: 94px;
  top: 47px;

  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbA5_Video {
  position: absolute;
  left: 244px;
  top: 55px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbA5_dotCard {
  position: absolute;
  left: 204px;
  top: 71px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

/* A6攤位區 */

.TopicA6_Banner01 {
  position: absolute;
  left: 334px;
  top: 224px;
  width: 80px;
  height: 160px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicA6_Banner01 {
  position: absolute;
  left: 118px;
  top: 81px;
  width: 28px;
  height: 56px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicA6_Banner02 {
  position: absolute;
  left: 427px;
  top: 224px;
  width: 81px;
  height: 160px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicA6_Banner02 {
  position: absolute;
  left: 152px;
  top: 81px;
  width: 28px;
  height: 56px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicA6_Video {
  position: absolute;
  left: 166px;
  top: 247px;
  width: 116px;
  height: 77px;
}

.mTopicA6_Video {
  position: absolute;
  left: 59px;
  top: 88px;
  width: 41px;
  height: 27px;
}

.TopicA6_dot1 {
  position: absolute;
  left: 368px;
  top: 201px;

  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA6_dot2 {
  position: absolute;
  left: 461px;
  top: 201px;

  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA6_dotVideo {
  position: absolute;
  left: 218px;
  top: 219px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA6_dotCard {
  position: absolute;
  left: 661px;
  top: 364px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicA6_staffArea {
  position: absolute;
  left: -31px;
  top: -110px;
  width: 85px;
  height: 202px;
}

.TopicMbA6_dot1 {
  position: absolute;
  left: 127px;
  top: 62px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbA6_dot2 {
  position: absolute;
  left: 161px;
  top: 62px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbA6_Video {
  position: absolute;
  left: 74px;
  top: 68px;

  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbA6_dotCard {
  position: absolute;
  left: 232px;
  top: 122px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

/* B1攤位區 */

.TopicB1_Banner01 {
  position: absolute;
  left: 42px;
  top: 226px;
  width: 84px;
  height: 151px;
  border: 1px solid rgb(163, 159, 159);
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicB1_Banner01 {
  position: absolute;
  left: 14px;
  top: 80px;
  width: 31px;
  height: 54px;
  border: 1px solid rgb(163, 159, 159);
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicB1_Banner02 {
  position: absolute;
  left: 159px;
  top: 227px;
  width: 80px;
  height: 147px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicB1_Banner02 {
  position: absolute;
  left: 56px;
  top: 81px;
  width: 29px;
  height: 52px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicB1_Banner03 {
  position: absolute;
  left: 270px;
  top: 228px;
  width: 80px;
  height: 145px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicB1_Banner03 {
  position: absolute;
  left: 96px;
  top: 81px;
  width: 28px;
  height: 51px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicB1_Banner04 {
  position: absolute;
  left: 380px;
  top: 232px;
  width: 79px;
  height: 144px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicB1_Banner04 {
  position: absolute;
  left: 135px;
  top: 82px;
  width: 28px;
  height: 52px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicB1_Video {
  position: absolute;
  left: 687px;
  top: 167px;
  width: 133px;
  height: 78px;
}

.mTopicB1_Video {
  position: absolute;
  left: 244px;
  top: 59px;
  width: 48px;
  height: 28px;
}

.TopicB1_dot1 {
  position: absolute;
  left: 78px;
  top: 200px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB1_dot2 {
  position: absolute;
  left: 192px;
  top: 200px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB1_dot3 {
  position: absolute;
  left: 303px;
  top: 200px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB1_dot4 {
  position: absolute;
  left: 412px;
  top: 200px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB1_dotVideo {
  position: absolute;
  left: 748px;
  top: 139px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB1_dotCard {
  position: absolute;
  left: 772px;
  top: 365px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB1_staffArea {
  position: absolute;
  left: -45px;
  top: -110px;
  width: 114px;
  height: 160px;
}

.TopicMbB1_dot1 {
  position: absolute;
  left: 22px;
  top: 60px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB1_dot2 {
  position: absolute;
  left: 64px;
  top: 60px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB1_dot3 {
  position: absolute;
  left: 103px;
  top: 60px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB1_dot4 {
  position: absolute;
  left: 144px;
  top: 60px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB1_Video {
  position: absolute;
  left: 261px;
  top: 37px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB1_dotCard {
  position: absolute;
  left: 278px;
  top: 128px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

/* B2攤位區 */

.img-thumbnailB2 {
  border: 1px solid #d3d2d0;
  border-radius: 0.15rem;
  max-width: 100%;
  height: auto;
}

.TopicB2_Banner01 {
  position: absolute;
  left: 85px;
  top: 244px;
  width: 74px;
  height: 128px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicB2_Banner01 {
  position: absolute;
  left: 30px;
  top: 86px;
  width: 27px;
  height: 46px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicB2_Banner02 {
  position: absolute;
  left: 176px;
  top: 244px;
  width: 74px;
  height: 128px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicB2_Banner02 {
  position: absolute;
  left: 63px;
  top: 86px;
  width: 26px;
  height: 46px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicB2_Banner03 {
  position: absolute;
  left: 267px;
  top: 244px;
  width: 74px;
  height: 128px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicB2_Banner03 {
  position: absolute;
  left: 96px;
  top: 86px;
  width: 26px;
  height: 46px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicB2_Banner04 {
  position: absolute;
  left: 358px;
  top: 244px;
  width: 74px;
  height: 128px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicB2_Banner04 {
  position: absolute;
  left: 127px;
  top: 86px;
  width: 27px;
  height: 46px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicB2_Video {
  position: absolute;
  left: 482px;
  top: 254px;
  width: 112px;
  height: 66px;
}

.mTopicB2_Video {
  position: absolute;
  left: 171px;
  top: 90px;
  width: 40px;
  height: 24px;
}

.TopicB2_dot1 {
  position: absolute;
  left: 115px;
  top: 214px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB2_dot2 {
  position: absolute;
  left: 206px;
  top: 214px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB2_dot3 {
  position: absolute;
  left: 297px;
  top: 214px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB2_dot4 {
  position: absolute;
  left: 388px;
  top: 214px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB2_dotVideo {
  position: absolute;
  left: 530px;
  top: 228px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB2_dotCard {
  position: absolute;
  left: 732px;
  top: 245px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB2_staffArea {
  position: absolute;
  left: -45px;
  top: 20px;
  width: 115px;
  height: 80px;
}

.TopicMbB2_dot1 {
  position: absolute;
  left: 37px;
  top: 66px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB2_dot2 {
  position: absolute;
  left: 70px;
  top: 66px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB2_dot3 {
  position: absolute;
  left: 103px;
  top: 66px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB2_dot4 {
  position: absolute;
  left: 135px;
  top: 66px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB2_Video {
  position: absolute;
  left: 185px;
  top: 69px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB2_dotCard {
  position: absolute;
  left: 254px;
  top: 78px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

/* B3攤位區 */

.img-thumbnailB3 {
  border: 2px solid #d5d2d0;
  border-radius: 0.15rem;
  max-width: 100%;
  height: auto;
}

.TopicB3_Banner01 {
  position: absolute;
  left: 157px;
  top: 207px;
  width: 50px;
  height: 99px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicB3_Banner01 {
  position: absolute;
  left: 56px;
  top: 73px;
  width: 18px;
  height: 36px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicB3_Banner02 {
  position: absolute;
  left: 219px;
  top: 207px;
  width: 50px;
  height: 99px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicB3_Banner02 {
  position: absolute;
  left: 78px;
  top: 73px;
  width: 18px;
  height: 36px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicB3_Banner03 {
  position: absolute;
  left: 279px;
  top: 207px;
  width: 50px;
  height: 99px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicB3_Banner03 {
  position: absolute;
  left: 99px;
  top: 73px;
  width: 18px;
  height: 36px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicB3_Banner04 {
  position: absolute;
  left: 341px;
  top: 207px;
  width: 50px;
  height: 99px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicB3_Banner04 {
  position: absolute;
  left: 121px;
  top: 73px;
  width: 18px;
  height: 36px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicB3_Video {
  position: absolute;
  left: 429px;
  top: 209px;
  width: 105px;
  height: 60px;
}

.mTopicB3_Video {
  position: absolute;
  left: 153px;
  top: 75px;
  width: 37px;
  height: 20px;
}

.TopicB3_dot1 {
  position: absolute;
  left: 176px;
  top: 188px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB3_dot2 {
  position: absolute;
  left: 238px;
  top: 188px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB3_dot3 {
  position: absolute;
  left: 299px;
  top: 188px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB3_dot4 {
  position: absolute;
  left: 360px;
  top: 188px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB3_dotVideo {
  position: absolute;
  left: 477px;
  top: 167px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB3_dotCard {
  position: absolute;
  left: 662px;
  top: 275px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB3_staffArea {
  position: absolute;
  left: -37px;
  top: -40px;
  width: 90px;
  height: 80px;
}

.TopicMbB3_dot1 {
  position: absolute;
  left: 59px;
  top: 55px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB3_dot2 {
  position: absolute;
  left: 81px;
  top: 55px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB3_dot3 {
  position: absolute;
  left: 102px;
  top: 55px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB3_dot4 {
  position: absolute;
  left: 124px;
  top: 55px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB3_Video {
  position: absolute;
  left: 166px;
  top: 55px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB3_dotCard {
  position: absolute;
  left: 232px;
  top: 91px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

/* B4攤位區 */

.img-thumbnailB4 {
  border: 2px solid #cfcbc7;
  border-radius: 0.15rem;
  max-width: 100%;
  height: auto;
}

.TopicB4_Banner01 {
  position: absolute;
  left: 266px;
  top: 247px;
  width: 57px;
  height: 113px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicB4_Banner01 {
  position: absolute;
  left: 94px;
  top: 88px;
  width: 21px;
  height: 40px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicB4_Banner02 {
  position: absolute;
  left: 337px;
  top: 247px;
  width: 57px;
  height: 113px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicB4_Banner02 {
  position: absolute;
  left: 120px;
  top: 88px;
  width: 21px;
  height: 40px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicB4_Banner03 {
  position: absolute;
  left: 461px;
  top: 247px;
  width: 57px;
  height: 113px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicB4_Banner03 {
  position: absolute;
  left: 164px;
  top: 88px;
  width: 21px;
  height: 40px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicB4_Banner04 {
  position: absolute;
  left: 531px;
  top: 247px;
  width: 57px;
  height: 113px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.mTopicB4_Banner04 {
  position: absolute;
  left: 189px;
  top: 88px;
  width: 21px;
  height: 40px;
  transition: all 1s;
  background-size: cover;
  background-repeat: no-repeat;
}

.TopicB4_Video {
  position: absolute;
  left: 742px;
  top: 251px;
  width: 114px;
  height: 64px;
}

.mTopicB4_Video {
  position: absolute;
  left: 264px;
  top: 89px;
  width: 40px;
  height: 23px;
}

.TopicB4_dot1 {
  position: absolute;
  left: 288px;
  top: 227px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB4_dot2 {
  position: absolute;
  left: 358px;
  top: 227px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB4_dot3 {
  position: absolute;
  left: 482px;
  top: 227px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB4_dot4 {
  position: absolute;
  left: 552px;
  top: 227px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB4_dotVideo {
  position: absolute;
  left: 790px;
  top: 227px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicB4_dotCard {
  position: absolute;
  left: 160px;
  top: 320px;
  width: 100px;
  animation: flicker 1s linear infinite;
}

.TopicB4_staffArea {
  position: absolute;
  left: -35px;
  top: -70px;
  width: 80px;
  height: 100px;
}

.TopicMbB4_dot1 {
  position: absolute;
  left: 99px;
  top: 70px;

  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB4_dot2 {
  position: absolute;
  left: 125px;
  top: 70px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB4_dot3 {
  position: absolute;
  left: 169px;
  top: 70px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB4_dot4 {
  position: absolute;
  left: 193px;
  top: 70px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB4_Video {
  position: absolute;
  left: 278px;
  top: 69px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.TopicMbB4_dotCard {
  position: absolute;
  left: 237px;
  top: 102px;
  animation: flicker 1s linear infinite;
  color: #535353;
}

.card-header {
  background-color: #e9ecef;
}

@media screen and (max-width: 576px) {
  .card {
    margin-top: 12px;
  }

  .card-header {
    padding: 0.5rem 1.25rem;
  }

  .card-body {
    padding: 1.2rem;
  }

  .btn {
    padding: 0.285rem 0.35rem;
    font-size: 0.9rem;
  }
}

.col,
.col-1,
.col-10,
.col-11,
.col-12,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-auto,
.col-lg,
.col-lg-1,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-auto,
.col-sm,
.col-sm-1,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-auto,
.col-xl,
.col-xl-1,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-auto {
  position: relative;
  width: 100%;
  padding-right: 5px;
  padding-left: 5px;
}

.topUK {
  position: relative;
}

.insideUK {
  position: absolute;
  top: 0;
  right: 0;
  /* background-color: rgba(52, 152, 177, 0.712); */
  width: 100%;
  height: 95%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #5e5e5ecc;
}

.UKframe {
  position: absolute;
  top: 0;
  right: 0;
  /* background-color: #b8bdbf78; */
  width: 100%;
  height: 95%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.homesection {
  background-image: url("../../../assets/images/onlineExpo_booth_bg.jpg");
  background-size: cover;
  background-position: center center;
  height: 630px;
  z-index: 998;
  margin-top: 50px;
}

.title_fontStyle {
  color: #326f8b;
}

a:hover {
  color: #707272;
  text-decoration: none;
}

a {
  color: #2d2e2e;
}

.modal-content {
  height: 82vh;
}

.modal-body {
  overflow-y: scroll;
  overflow-x: hidden;

  height: 75vh;
}

.BannerHover:hover {
  box-shadow: 2px 2px 15px 8px rgba(255, 255, 255, 0.322);
  opacity: 0.8;
  cursor: pointer;
}

/* 卡片區 */
.card-header {
  margin-bottom: 0;
  background-color: #dadddd;
  border-bottom: 0px;
  position: relative;
}

.card {
  -webkit-box-shadow: -1px 1px 24px -7px rgba(92, 89, 92, 0.09);
  -moz-box-shadow: -1px 1px 24px -7px rgba(92, 89, 92, 0.09);
  box-shadow: -1px 1px 24px -7px rgba(92, 89, 92, 0.09);
}

.profileCard {
  min-height: 310px;
}

/* 標題超出設定... */
.ellipsis_pro {
  font-size: 16px;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.ellipsis_exh {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.A1_Logobanner {
  position: absolute;
  right: 166px;
  top: 46px;
  width: 300px;
  min-height: 80px;
  border-radius: 2%;
  background-color: #eceff0;
}

.A2_Logobanner {
  position: absolute;
  right: 474px;
  top: 88px;
  width: 290px;
  min-height: 80px;
  border-radius: 2%;
  background-color: #eceff0;
}

.A3_Logobanner {
  position: absolute;
  right: 205px;
  top: 48px;
  width: 290px;
  min-height: 80px;
  border-radius: 2%;
  background-color: #eceff0;
}

.A4_Logobanner {
  position: absolute;
  right: 327px;
  top: 99px;
  width: 272px;
  min-height: 80px;
  border-radius: 2%;
  background-color: #eceff0;
}

.A5_Logobanner {
  position: absolute;
  right: 141px;
  top: 63px;
  width: 290px;
  min-height: 80px;
  border-radius: 2%;
  background-color: #eceff0;
}

.A6_Logobanner {
  position: absolute;
  right: 471px;
  top: 50px;
  width: 290px;
  min-height: 80px;
  border-radius: 2%;
  background-color: #eceff0;
}

.B1_Logobanner {
  position: absolute;
  right: 253px;
  top: 34px;
  width: 290px;
  min-height: 85px;
  border-radius: 2%;
  background-color: #eceff0;
}

.B2_Logobanner {
  position: absolute;
  right: 56px;
  top: 83px;
  width: 283px;
  min-height: 80px;
  border-radius: 2%;
  background-color: #eceff0;
}

.B3_Logobanner {
  position: absolute;
  right: 170px;
  top: 102px;
  width: 290px;
  min-height: 80px;
  border-radius: 2%;
  background-color: #eceff0;
}

.B4_Logobanner {
  position: absolute;
  right: 151px;
  top: 112px;
  width: 290px;
  min-height: 85px;
  border-radius: 2%;
  background-color: #eceff0;
}

.logImgFrame {
  width: 95px;
  min-height: 85px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Mbfooter {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  background: #82808059;
  color: #fff;
  height: 140px;
  border-top: 1px solid #b7b4b4;

  background-image: url("../../../assets/images/booth_icon_bg.jpg");
  background-size: cover;
  background-position: center center;
  z-index: 1;
}

.Booth_MbTop {
  position: relative;
  left: 0;
  top: 90px;
}

.MbLogobanner {
  position: absolute;
  left: 55px;
  top: -61px;
  width: 250px;
  min-height: 55px;
  border-radius: 5px;
  background-color: #eceff0;
  border: 1px solid #b6beca;
}

.MblogImgFrame {
  width: 50px;
  min-height: 50px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.LogoText {
  font-family: monospace;
  font-size: 10px;
  font-weight: 550;
}

@media (max-width: 576px) {
  .homesection {
    background-image: url("../../../assets/images/onlineExpo_booth_bg.jpg");
    background-size: cover;
    background-position: center center;
    height: 412px;
    z-index: 8;
    margin-top: 20px;
    position: relative;
  }

  .profileCard {
    min-height: 240px;
  }

  .modal-content {
    height: auto;
  }
}
</style>
